// @ts-nocheck
(() => {
  'use strict';

  const tr = window.vhpT; // snippets/vhp-i18n.liquid

  if (window.__vhpCollectionReelsLoaded) return;
  window.__vhpCollectionReelsLoaded = true;

  const likesApi = () => window.vhpPlannerLikes || null;
  // Anonymous recipe counters (assets/vhp-planner-events.js). A failure there never reaches the planner.
  const plannerEvents = (method, ...args) => {
    try {
      window.vhpPlannerEvents?.[method]?.(...args);
    } catch (err) {
      /* counters are optional */
    }
  };
  const ENTRY_SHIMMER_KEY = 'vhp-reel-entry-shimmer-shown';
  const INTRO_KEY = 'vhp_feed_intro_seen_v1';
  // A talk intro carries its video's id: a new intro video shows again to people who dismissed the old one.
  const introKey = (el) => (el?.dataset.introKey ? INTRO_KEY + ':' + el.dataset.introKey : INTRO_KEY);
  const NATIVE_SESSION_KEY = 'vhp_feed_native_v2';
  // Homepage intro test (docs/HOMEPAGE_FUNNEL.md, 2026-10-18; intro block setting "Test: half without intro"): a new
  // device that would get the intro gets an arm once, stable by the deck's seed: h_intro = the video first (as
  // before), h_feed = recipes first. assets/vhp-planner-events.js sends the arm with every step for 30 days.
  const TEST_KEY = 'vhp_home_test';
  const TEST_FEED_SHARE = 0.5;
  const introSeconds = (sec) => (sec <= 5 ? 'out_5' : sec <= 15 ? 'out_15' : sec <= 30 ? 'out_30' : 'out_more');

  const flag = (key) => {
    try {
      return localStorage.getItem(key) === '1';
    } catch (_) {
      return false;
    }
  };
  const setFlag = (key) => {
    try {
      localStorage.setItem(key, '1');
    } catch (_) {}
  };
  // Deck card timing for this visit: swipes so far, cards shown, swipe count at the last card (and per card).
  // Locked exclusive cards count apart: how many, swipe count at the last one, which recipes.
  const loadSession = () => {
    try {
      const raw = JSON.parse(sessionStorage.getItem(NATIVE_SESSION_KEY) || 'null');
      if (raw && typeof raw === 'object') {
        return {
          swipes: Number(raw.swipes) || 0,
          shown: Number(raw.shown) || 0,
          last: raw.last == null ? null : Number(raw.last),
          cards: raw.cards && typeof raw.cards === 'object' ? raw.cards : {},
          intro: Boolean(raw.intro),
          ex: Number(raw.ex) || 0,
          exLast: raw.exLast == null ? null : Number(raw.exLast),
          exIds: Array.isArray(raw.exIds) ? raw.exIds.map(String) : [],
        };
      }
    } catch (_) {}
    return { swipes: 0, shown: 0, last: null, cards: {}, intro: false, ex: 0, exLast: null, exIds: [] };
  };
  const saveSession = (session) => {
    try {
      sessionStorage.setItem(NATIVE_SESSION_KEY, JSON.stringify(session));
    } catch (_) {}
  };

  // When each recipe was last swiped on this device (id → ms). Orders the rotation once everything is seen:
  // the recipe not seen for the longest comes back first, liked or not. Likes/skips carry a time too, but a
  // left swipe on a liked recipe leaves no skip, and re-liking must not reorder the likes (they fill the week).
  const SEEN_KEY = 'vhp_feed_seen_v1';
  const SEEN_MAX = 800;
  // "Alles gesehen" screen: shown once per feed and catalog size (mode → number of recipes when shown).
  const DONE_KEY = 'vhp_feed_done_v1';
  // While new recipes are left, one liked recipe comes back every REVISIT_EVERY swipes (from REVISIT_MIN_LIKES likes).
  const REVISIT_EVERY = 10;
  const REVISIT_MIN_LIKES = 3;
  // Once everything is seen: every 4th card of the rotation is a skipped recipe (if any), the rest liked ones.
  const ROTATE_SKIPPED_EVERY = 4;
  // A skip older than this counts as not seen again (a skip is often "not now"); such recipes come after the
  // never-seen ones. Skipping one again renews the skip.
  const SKIP_EXPIRE_MS = 30 * 86400000;
  const staleSkip = (row) => {
    const at = Date.parse(row?.at || '');
    return Number.isFinite(at) && Date.now() - at > SKIP_EXPIRE_MS;
  };
  // Reel layout (docs/FEED_REEL.md, assets/vhp-reel-deck.js): scrolling past a card is a "pass", not a skip. The card
  // counts as seen (SEEN_KEY: it comes after the never-seen ones, never out of the plan) and, when she left it within
  // SOFT_PASS_MS, as a soft skip for the taste ranking only (PASS_KEY, id → ms; assets/vhp-deck-order.js browserTaste).
  const PASS_KEY = 'vhp_feed_pass_v1';
  const PASS_MAX = 400;
  const SOFT_PASS_MS = 1500;
  // Reel signals for the recipe stats (src feed_reel, docs/FEED_ORDER.md "Reel signals"): on screen this long when
  // she scrolls on = watched / watched long. Watched long, a recipe or calculator open and a share also mark the
  // card as a soft like for the taste ranking (ENGAGED_KEY, id → ms; assets/vhp-deck-order.js browserTaste).
  const WATCHED_MS = 4000;
  const WATCHED_LONG_MS = 12000;
  const ENGAGED_KEY = 'vhp_feed_engaged_v1';
  const dwellBucket = (ms) => (ms < 1500 ? 'under_1_5' : ms < 4000 ? 'under_4' : ms < 10000 ? 'under_10' : 'over_10');
  // Locked exclusive cards: at least this many swipes from any other deck card (both ways). Which exclusive was
  // shown when on this device (id → ms; one not shown for EX_FRESH_DAYS comes first), and which ones got a right
  // swipe (id → ms; for the planner later, docs/FEED_ORDER.md step 4).
  const EX_SPACING = 3;
  const EX_SEEN_KEY = 'vhp_feed_ex_seen_v1';
  const EX_FRESH_DAYS = 7;
  const EX_WANT_KEY = 'vhp_feed_ex_wants_v1';

  const readJson = (key) => {
    try {
      const raw = JSON.parse(localStorage.getItem(key) || 'null');
      return raw && typeof raw === 'object' ? raw : {};
    } catch (_) {
      return {};
    }
  };
  const writeJson = (key, value) => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (_) {}
  };
  // The intro test arm of this device: '' when the test is off or the deck order module is missing (then the intro
  // shows as before). Assigned on the first homepage load that would show the intro, then kept.
  const introArm = (introEl) => {
    if (!introEl || introEl.dataset.introTest !== 'true') return '';
    const saved = readJson(TEST_KEY);
    if (saved.arm === 'h_intro' || saved.arm === 'h_feed') return saved.arm;
    const order = window.vhpDeckOrder;
    if (!order) return '';
    const arm = order.rng(order.seed(order.browserSeed(), 'intro-test'))() < TEST_FEED_SHARE ? 'h_feed' : 'h_intro';
    writeJson(TEST_KEY, { arm, at: new Date().toISOString() });
    return arm;
  };

  const markSeen = (id) => {
    const seen = readJson(SEEN_KEY);
    seen[id] = Date.now();
    const ids = Object.keys(seen);
    if (ids.length > SEEN_MAX) {
      ids.sort((a, b) => seen[a] - seen[b]).slice(0, ids.length - SEEN_MAX).forEach((old) => delete seen[old]);
    }
    writeJson(SEEN_KEY, seen);
  };

  const markSoftPass = (id) => {
    const passes = readJson(PASS_KEY);
    passes[id] = Date.now();
    const ids = Object.keys(passes);
    if (ids.length > PASS_MAX) {
      ids.sort((a, b) => passes[a] - passes[b]).slice(0, ids.length - PASS_MAX).forEach((old) => delete passes[old]);
    }
    writeJson(PASS_KEY, passes);
  };
  const clearSoftPass = (id) => {
    const passes = readJson(PASS_KEY);
    if (!(id in passes)) return;
    delete passes[id];
    writeJson(PASS_KEY, passes);
  };
  const markEngaged = (id) => {
    const engaged = readJson(ENGAGED_KEY);
    engaged[id] = Date.now();
    const ids = Object.keys(engaged);
    if (ids.length > PASS_MAX) {
      ids.sort((a, b) => engaged[a] - engaged[b]).slice(0, ids.length - PASS_MAX).forEach((old) => delete engaged[old]);
    }
    writeJson(ENGAGED_KEY, engaged);
    clearSoftPass(id);
  };
  // Recipe stats source: the homepage reel has its own (its saves and watch time don't compare with swipes).
  const statsSrc = (state) => (state?.reel ? 'feed_reel' : 'overlay');
  // A reel signal for this card, once per page load (vhp-planner-events.js once); soft: also a soft like for taste.
  const reelSignal = (state, card, e, soft) => {
    if (!state?.reel || !card || card.native) return;
    plannerEvents('once', e, { id: card.id, slot: card.slot, src: 'feed_reel' });
    if (soft) markEngaged(card.id);
  };

  const prefersReducedMotion = () => {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (_) {
      return false;
    }
  };

  // Instagram / Facebook / TikTok in-app browser (same test as assets/vhp-planner-events.js).
  const inAppBrowser = () => /Instagram|FBAN|FBAV|FB_IAB|TikTok|musical_ly/i.test(navigator.userAgent || '');

  const hasSeenEntryShimmer = () => {
    try {
      return localStorage.getItem(ENTRY_SHIMMER_KEY) === '1';
    } catch (_) {
      return false;
    }
  };

  const markEntryShimmerSeen = () => {
    try {
      localStorage.setItem(ENTRY_SHIMMER_KEY, '1');
    } catch (_) {}
  };

  const playEntryShimmer = (entry) => {
    if (!entry || hasSeenEntryShimmer() || prefersReducedMotion()) return;

    const cleanup = () => {
      entry.classList.remove('is-shimmering');
      entry.removeEventListener('animationend', onEnd);
      entry.removeEventListener('click', onClick);
      markEntryShimmerSeen();
    };
    const onEnd = (e) => {
      if (e.animationName !== 'vhp-reel-entry-shimmer') return;
      cleanup();
    };
    const onClick = () => cleanup();

    window.setTimeout(() => {
      if (hasSeenEntryShimmer()) return;
      entry.classList.add('is-shimmering');
      entry.addEventListener('animationend', onEnd);
      entry.addEventListener('click', onClick, { once: true });
    }, 1200);
  };

  const isReelModeParam = () => {
    const v = new URLSearchParams(window.location.search).get('reel_mode');
    return v === 'true' || v === '1';
  };

  const stripReelModeParam = () => {
    try {
      const url = new URL(window.location.href);
      if (!url.searchParams.has('reel_mode')) return;
      url.searchParams.delete('reel_mode');
      const qs = url.searchParams.toString();
      const next = url.pathname + (qs ? `?${qs}` : '') + url.hash;
      window.history.replaceState(window.history.state, '', next);
    } catch (_) {}
  };

  const endReelBoot = () => {
    document.documentElement.classList.remove('vhp-reel-boot');
  };

  const num = (value) => {
    if (value == null || value === '') return null;
    const n = Number(value);
    return Number.isFinite(n) ? n : null;
  };

  const shuffleArray = (arr) => {
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  };

  const stateByOverlay = new WeakMap();
  const deckByOverlay = new WeakMap();

  const $ = (overlay, sel) => overlay.querySelector(sel);

  const showShareToast = (message) => {
    const toast = document.createElement('div');
    toast.setAttribute('role', 'status');
    toast.textContent = message;
    Object.assign(toast.style, {
      position: 'fixed',
      left: '50%',
      bottom: 'calc(24px + env(safe-area-inset-bottom))',
      transform: 'translateX(-50%)',
      padding: '10px 16px',
      borderRadius: '999px',
      background: 'rgba(0, 0, 0, 0.82)',
      color: '#fff',
      fontSize: '13px',
      zIndex: '10000',
      pointerEvents: 'none',
    });
    document.body.appendChild(toast);
    window.setTimeout(() => toast.remove(), 1500);
  };

  const readSourceCard = (el, api) => {
    if (!el || el.hasAttribute('data-vhp-reel-skip')) return null;
    if (el.dataset.plannable !== 'true') return null;
    const id = api.productId(el.dataset.id);
    const slot = el.dataset.slot;
    if (!id || !api.SLOT_ORDER.includes(slot)) return null;
    const link = el.querySelector('.recipe-card__link');
    return {
      id,
      handle: el.dataset.handle || '',
      title: el.dataset.title || el.querySelector('.card-title')?.textContent.trim() || '',
      image: el.dataset.image || el.dataset.poster || el.querySelector('.card-img img')?.src || '',
      slot,
      kcal: num(el.dataset.kcal),
      protein: num(el.dataset.protein),
      carbs: num(el.dataset.carbs),
      fat: num(el.dataset.fat),
      time: num(el.dataset.time),
      tags: el.dataset.tags || '',
      href: el.dataset.href || (link && link.getAttribute('href')) || '#',
      el,
    };
  };

  const collectSources = (grid, api, shuffle) => {
    const cards = [...grid.querySelectorAll('.recipe-card.card-media-full')]
      .map((el) => readSourceCard(el, api))
      .filter(Boolean);
    const seen = new Set();
    const unique = [];
    cards.forEach((card) => {
      if (seen.has(card.id)) return;
      seen.add(card.id);
      unique.push(card);
    });
    return shuffle ? shuffleArray(unique) : unique;
  };

  // Ranked deck order (assets/vhp-deck-order.js): the loaded cards right away, the whole feed once its index is
  // in (vhpFeed.ranking, assets/vhp-home-feed.js). state.lead, the server's first card, stays in front, behind
  // state.front (the newest recipes for in-app visitors, openOverlay). Without the module the sources are shuffled
  // instead (collectSources).
  const rankSources = (state) => {
    const order = window.vhpDeckOrder;
    if (!state.ranked || !order) return;
    let pos = state.rank;
    if (!pos) {
      const seed = order.seed(order.browserSeed(), 'deck');
      const ids = order.rank(state.sources, { stats: order.pageStats(), seed, now: Date.now(), taste: order.browserTaste() }).cards.map((c) => c.id);
      pos = new Map(ids.map((id, i) => [id, i]));
    }
    const front = state.front || [];
    const at = (card) => {
      const i = front.indexOf(card.id);
      if (i >= 0) return i - front.length - 1;
      return card.id === state.lead ? -1 : pos.has(card.id) ? pos.get(card.id) : Infinity;
    };
    state.sources = state.sources
      .map((card, i) => ({ card, i }))
      .sort((a, b) => at(a.card) - at(b.card) || a.i - b.i)
      .map((row) => row.card);
  };

  // Recipes ranked before the deck's third card that aren't loaded yet: true (once per chunk of them) so the
  // deck fetches them now instead of after page 1 runs out.
  const RANK_CHUNK = 4; // UNSEEN_CHUNK in assets/vhp-home-feed.js
  const rankGap = (state, plan, api) => {
    if (!state.rankIds || plan.cards.length < 3) return false;
    const cut = state.rank.get(plan.cards[2].id);
    const end = cut == null ? state.rankIds.length : cut;
    const doc = api.read();
    const skip = new Set([...state.sources.map((card) => card.id), ...doc.likes.items.map((item) => item.id), ...doc.skips.items.map((item) => item.id)]);
    const missing = [];
    for (let i = 0; i < end && missing.length < RANK_CHUNK; i += 1) {
      const id = state.rankIds[i];
      if (!skip.has(id) && !state.rankTried.has(id)) missing.push(id);
    }
    missing.forEach((id) => state.rankTried.add(id));
    return missing.length > 0;
  };

  // Deck order. Recipes not swiped yet come first; while there are some, a liked recipe comes back every
  // REVISIT_EVERY swipes (each once per visit). Once everything loaded is seen (more may still be loading),
  // all recipes rotate: liked ones with a skipped one every ROTATE_SKIPPED_EVERY cards, each group starting
  // with the recipe not seen for the longest. `fresh` says which of the two the deck is in.
  const deckPlan = (state, api) => {
    const doc = api.read();
    const liked = new Map(doc.likes.items.map((item) => [item.id, item]));
    const skipped = new Map(doc.skips.items.map((item) => [item.id, item]));
    const seenAt = readJson(SEEN_KEY);
    const lastSeen = (id) =>
      Math.max(Number(seenAt[id]) || 0, Date.parse(liked.get(id)?.at) || 0, Date.parse(skipped.get(id)?.at) || 0);
    const byOldest = (a, b) => lastSeen(a.id) - lastSeen(b.id);
    const accept = window.vhpFeed?.accept;
    const unseen = [];
    const stale = [];
    const seen = [];
    // Reel layout: cards she scrolled past (seen, neither liked nor skipped) come after the never-seen ones.
    const passed = [];
    state.sources.forEach((card) => {
      if (!card.id || (accept && !accept(card))) return;
      if (liked.has(card.id)) seen.push(card);
      else if (!skipped.has(card.id)) (state.reel && seenAt[card.id] ? passed : unseen).push(card);
      else (staleSkip(skipped.get(card.id)) ? stale : seen).push(card);
    });
    passed.sort(byOldest);
    unseen.push(...stale, ...passed);
    const fresh = unseen.length > 0;
    let cards = unseen;
    if (!fresh) {
      // Liked recipes lead the rotation; a skipped one only every ROTATE_SKIPPED_EVERY cards.
      const likedCards = seen.filter((card) => liked.has(card.id)).sort(byOldest);
      const skippedCards = seen.filter((card) => !liked.has(card.id)).sort(byOldest);
      // The plan is rebuilt after every swipe, so the first run counts the liked cards since the last skipped one.
      let lead = Math.max(0, ROTATE_SKIPPED_EVERY - 1 - state.sinceSkipped);
      cards = [];
      while (likedCards.length || skippedCards.length) {
        cards.push(...likedCards.splice(0, lead));
        if (skippedCards.length) cards.push(skippedCards.shift());
        lead = ROTATE_SKIPPED_EVERY - 1;
      }
    }
    else if (state.sinceRevisit >= REVISIT_EVERY && liked.size >= REVISIT_MIN_LIKES) {
      const revisit = seen.filter((card) => liked.has(card.id) && !state.revisited.has(card.id)).sort(byOldest)[0];
      if (revisit) cards = [revisit, ...unseen];
    }
    if (state.pin) {
      // The recipe article's own card is shown even when the feed filters would hide it.
      const pinned = state.sources.find(
        (card) => card.id === state.pin && (card.id === state.root?.dataset.entryCard || !accept || accept(card))
      );
      if (pinned) cards = [pinned, ...cards.filter((card) => card !== pinned)];
    }
    if (state.deferId && cards.length > 1 && cards[0].id === state.deferId) {
      cards.push(cards.shift());
    }
    return { cards, fresh, liked, seen };
  };

  const remainingCards = (state, api) => deckPlan(state, api).cards;

  // Another page can still come (paging button present, not exhausted, maybe loading right now).
  const canLoadMore = (state) => {
    const wrap = state.root?.querySelector('#loadMoreWrap');
    const btn = state.root?.querySelector('#loadMoreBtn');
    if (!wrap || !btn || wrap.style.display === 'none') return false;
    return wrap.dataset.nextPage === undefined || wrap.dataset.nextPage !== '';
  };

  const asLike = (card, api) =>
    api.normalizeLikeItem({
      id: card.id,
      handle: card.handle,
      title: card.title,
      image: card.image,
      slot: card.slot,
      kcal: card.kcal,
      protein: card.protein,
      carbs: card.carbs,
      fat: card.fat,
      time: card.time,
      at: new Date().toISOString(),
    });

  const pauseVideos = (root) => {
    root?.querySelectorAll('video').forEach((video) => {
      try {
        video.pause();
      } catch (_) {}
    });
  };

  // Card under the top one; the "In deinen Likes" tag is filled by the deck's face hook (openOverlay).
  const fillPeek = (state, card) => state.deck.showNext(card);

  // Top card: the recipe link for the sheet, the deck does the rest (assets/vhp-swipe-deck.js).
  const fillCard = (overlay, state, card) => {
    // The same card painted again (a like, a filter): not shown twice for the recipe stats.
    const again = state.current?.id === card.id && !state.current.native;
    state.current = card;
    if (overlay.classList.contains('is-open') && !again) {
      plannerEvents('shown', { id: card.id, slot: card.slot, src: statsSrc(state) });
    }
    const recipe = $(overlay, '[data-vhp-swipe-recipe]');
    if (recipe) recipe.setAttribute('href', card.href || '#');
    state.deck.show(card, { force: true });
  };

  // The card on screen: in the reel layout a history card she scrolled back to, else the one at the front.
  const onScreen = (state) => state.deck.viewing || state.current;
  const isLiked = (api, card) => Boolean(card && !card.native && api.read().likes.items.some((row) => row.id === card.id));

  // Already liked (a revisit or the rotation): filled heart on the like button and a small "In deinen Likes" tag.
  // Reel layout: the one button reads "Gemerkt ✓" instead of "Will ich kochen".
  // Reel layout: every card carries its own button (snippets/vhp-swipe-deck.liquid reel: true); slide = a history card
  // (assets/vhp-reel-deck.js viewingSlide), else the front card.
  const paintCta = (cta, on) => {
    if (!cta) return;
    cta.setAttribute('aria-pressed', on ? 'true' : 'false');
    cta.classList.toggle('is-on', on);
    const label = cta.querySelector('.vhp-reel-cta__label');
    if (label) label.textContent = on ? tr('reels.cta_saved') : tr('reels.cta_cook');
  };
  const paintLiked = (overlay, on, slide) => {
    if (slide) {
      const tag = slide.querySelector('.vhp-swipe-card__liked');
      if (tag) tag.hidden = !on;
      paintCta(slide.querySelector('.vhp-reel-cta'), on);
      return;
    }
    overlay.toggleAttribute('data-liked', on);
    const tag = $(overlay, '[data-vhp-swipe-liked]');
    if (tag) tag.hidden = !on;
    const take = $(overlay, '[data-vhp-swipe="take"]');
    if (take) take.setAttribute('aria-label', on ? tr('reels.liked_keep') : tr('reels.like'));
    paintCta($(overlay, '[data-vhp-swipe-card] .vhp-reel-cta'), on);
  };

  const renderMeter = (overlay, state, api) => {
    const doc = api.read();
    const paid = overlay.dataset.vhpPlannerPaid === 'true';
    const href = overlay.dataset.vhpPlannerUrl || '/pages/meal-planner';
    if (window.vhpSwipeWeek && typeof api.weekView === 'function') {
      try {
        // "Dein Plan ist fertig" fires on the like that fills the week (not gated by the native-card gap), but never
        // over a native card; once open it stays until closed.
        const successOk = window.vhpSwipeWeek.holding?.(overlay) || !state.nativeActive;
        window.vhpSwipeWeek.render(overlay, api.weekView(doc), {
          paid,
          // Reel layout: no success modal; the planner card is a slide after the third save (pickNative "ready").
          allowSuccess: !paid && state.celebrate && successOk && !state.reel,
          // "Deine Woche steht" on the like that makes a plan (3 incl. a main), as the Plan tab's ✓; 5 liked mains
          // were reached by under 7 % of homepage visitors (docs/CONVERSION_PLAN.md).
          celebrateAt: 'ready',
          onSuccess: () => {
            state.session.last = state.session.swipes;
            saveSession(state.session);
          },
          plannerUrl: href,
          onPlan: () => {
            if (typeof window.vhpTrack === 'function') {
              window.vhpTrack('reel_plan_cta', { paid });
            }
            window.location.href = href;
          },
        });
      } catch (e) {
        /* week chrome must not block the deck */
      }
    }
    state.wasReady = api.planReady(doc);
    state.wasVariety = api.likeCount(doc) >= api.LIKE_VARIETY;
  };

  // The save progress in the top bar's row (2026-11-01, docs/FEED_REEL.md 8): "Wochenplan 1/3" with their saved
  // dishes as thumbnails, the word the card's "In den Wochenplan" button uses, from the first save on; "Noch 1
  // Hauptgericht" when only a main is missing; "Woche planen" once the saves make a plan (a tap goes to the planner,
  // before that it opens "Deine Likes bisher"). Only rendered for non-subscribers (snippets/vhp-reel-overlay.liquid);
  // hidden over deck cards, the success card and "Alles gesehen". A short pop when the text changes.
  const paintProgress = (overlay, state, api) => {
    const pill = $(overlay, '[data-vhp-feed-progress]');
    if (!pill || !state || !api) return;
    const doc = api.read();
    const view = api.weekView(doc);
    const left = Number(view.readyLeft) || 0;
    const count = api.likeCount(doc);
    const show =
      count > 0 &&
      !state.nativeActive &&
      !state.doneOpen &&
      !state.stripOpen &&
      !state.calcOpen &&
      !state.deck.card.hidden &&
      !window.vhpSwipeWeek?.holding?.(overlay);
    if (!show) {
      pill.hidden = true;
      state.progressText = null;
      return;
    }
    const total = api.LIKE_READY;
    // As the Plan tab's badge (assets/app-shell.js): the last place waits for a main.
    const done = view.needMain ? Math.min(count, total - 1) : Math.min(count, total);
    const ready = Boolean(view.ready);
    const text = ready
      ? tr('week.progress_pill_ready')
      : view.needMain && left <= 1
        ? tr('week.progress_pill_main')
        : tr('week.progress_pill', { done, total });
    const changed = state.progressText != null && state.progressText !== text;
    state.progressText = text;
    $(pill, '[data-vhp-feed-progress-text]').textContent = text;
    pill.classList.toggle('is-ready', ready);
    if (!pill.dataset.label) pill.dataset.label = pill.getAttribute('aria-label') || '';
    pill.setAttribute('aria-label', ready ? tr('week.progress_pill_ready_label') : pill.dataset.label);
    pill.setAttribute('aria-haspopup', ready ? 'false' : 'dialog');
    // Their newest likes as thumbnails, one place per like a plan needs; the open places dashed.
    const dots = $(pill, '[data-vhp-feed-progress-dots]');
    if (dots) {
      const recent = api.likeItems(doc).slice(-api.LIKE_READY);
      dots.replaceChildren(
        ...Array.from({ length: api.LIKE_READY }, (_, i) => {
          const dot = document.createElement('span');
          dot.className = 'vhp-feed-progress__dot';
          const item = recent[i];
          if (item?.image) {
            const img = document.createElement('img');
            img.alt = '';
            img.src = item.image;
            dot.append(img);
          } else if (!item) dot.classList.add('is-open');
          return dot;
        })
      );
    }
    pill.hidden = false;
    if (changed && !prefersReducedMotion()) {
      pill.classList.remove('is-pop');
      void pill.offsetWidth;
      pill.classList.add('is-pop');
    }
  };

  // "Deine Likes bisher" (the progress line's sheet, docs/HOMEPAGE_FUNNEL.md): their likes, what happens with them, and
  // the way into the planner before the third like (planner_entry feed_strip). The planner's deck fills the rest.
  const stripEl = (overlay) => $(overlay, '[data-vhp-feed-strip]');
  const stripMeta = (item) =>
    [
      num(item.protein) != null ? tr('common.protein', { n: Math.round(item.protein) }) : '',
      num(item.time) ? tr('common.min', { n: Math.round(item.time) }) : '',
    ]
      .filter(Boolean)
      .join(' · ');
  const openStrip = (overlay, state, api) => {
    const el = stripEl(overlay);
    if (!el || state.stripOpen) return;
    const list = $(el, '[data-vhp-feed-strip-list]');
    list?.replaceChildren(
      ...api
        .likeItems(api.read())
        .slice(-6)
        .reverse()
        .map((item) => {
          const li = document.createElement('li');
          li.className = 'vhp-feed-strip__item';
          const pic = document.createElement(item.image ? 'img' : 'span');
          if (item.image) {
            pic.src = item.image;
            pic.alt = '';
          } else pic.className = 'vhp-feed-strip__ph';
          const text = document.createElement('div');
          const title = document.createElement('strong');
          title.textContent = item.title || tr('common.recipe');
          text.append(title);
          const meta = stripMeta(item);
          if (meta) {
            const sub = document.createElement('span');
            sub.textContent = meta;
            text.append(sub);
          }
          li.append(pic, text);
          return li;
        })
    );
    state.stripOpen = true;
    paintProgress(overlay, state, api);
    state.deck.media?.querySelector('video')?.pause();
    el.hidden = false;
    void el.offsetWidth; // commit the closed position, then slide in
    el.classList.add('is-open');
    $(el, '.vhp-feed-strip__copy')?.focus({ preventScroll: true });
    plannerEvents('step', 'week_strip', 'open');
    window.vhpTrack?.('feed_strip_open', { likes: api.likeCount() });
  };
  const closeStrip = (overlay, state) => {
    const el = stripEl(overlay);
    if (!el || !state.stripOpen) return;
    state.stripOpen = false;
    el.classList.remove('is-open');
    window.setTimeout(() => {
      if (!state.stripOpen) el.hidden = true;
    }, prefersReducedMotion() ? 0 : 320);
    const video = state.deck.media?.querySelector('video');
    if (video && video.dataset.userPaused !== '1') video.play()?.catch?.(() => {});
    const api = likesApi();
    if (api) paintProgress(overlay, state, api);
  };

  // "Für dich" on the swipe card (docs/HOMEPAGE_FUNNEL.md): their portion of the dish once a day target is known
  // (window.vhpPortionCalc, assets/vhp-plan-goal.js: the planner's, this visit's calculator answers, or the remembered
  // one), else "Meine Portion berechnen" for non-subscribers. The peeking card mirrors the line as plain text. The
  // strings ride on the top card's button (data-t-*).
  const fillT = (template, vars) => String(template || '').replace(/\{(\w+)\}/g, (m, k) => (k in vars ? String(vars[k]) : m));
  const faceCards = new WeakMap(); // overlay → { swipe, 'swipe-under' }: the dishes on the two faces, for repaints
  // "**1¼ Portionen** für dich · 835 kcal" (the amount bold, one line; protein per portion is in the calculator), or
  // "Meine Portion berechnen", or nothing: { label, amount, p, slots, meta } for a dish.
  // "Portion statt Nährwerte" (theme setting reel_portion_slots, 2026-11-03): the pill stands in for the dish's kcal
  // and protein; the whole row leaves the card, time too. Two lines: "Deine Portion für dein Ziel" over "? kcal · ? g
  // Protein", each "?" an empty slot ('\u0001' in meta), "Ausrechnen ›" on the right, until a target is known; then "**¾ Portion** für dich" over "412 kcal · 31 g
  // Protein". Off: the dish's numbers plus the ask "Wie viel davon ist meine Portion?".
  const forYouParts = (overlay, card) => {
    const btn = $(overlay, '[data-vhp-swipe-foryou]');
    if (!btn) return null;
    const calc = window.vhpPortionCalc;
    const paid = overlay.dataset.vhpPlannerPaid === 'true';
    const slotsOn = overlay.hasAttribute('data-vhp-portion-slots');
    const dish = card && !card.native ? card : null;
    const known = Boolean(calc?.day?.());
    const p = dish && known ? calc.portion(dish) : null;
    let amount = '';
    let label = '';
    if (p) {
      amount = fillT(p.scale <= 1 ? btn.dataset.tOne : btn.dataset.tOther, { n: p.amount });
      label = fillT(slotsOn ? btn.dataset.tSlotYours : btn.dataset.tYours, { amount: '\u0000', kcal: p.kcal });
    } else if (dish && !known && !paid && calc) label = slotsOn ? btn.dataset.tSlot : btn.dataset.tAsk;
    const slots = Boolean(slotsOn && label);
    const meta = slots ? fillT(btn.dataset.tMeta, p ? { kcal: p.kcal, protein: p.protein } : { kcal: '\u0001', protein: '\u0001' }) : '';
    return { label, amount, p, slots, meta };
  };
  const slotChip = () => Object.assign(document.createElement('span'), { className: 'vhp-swipe-card__foryou-q', textContent: '?' });
  const writeForYou = (el, text, parts) => {
    el.hidden = !parts.label;
    el.classList.toggle('is-yours', Boolean(parts.p));
    el.classList.toggle('is-slots', parts.slots);
    const macros = el.parentElement?.querySelector('.vhp-swipe-card__macros');
    if (macros) macros.hidden = parts.slots;
    if (el.matches('button')) {
      if (parts.slots && !parts.p && el.dataset.tSlotAria) el.setAttribute('aria-label', el.dataset.tSlotAria);
      else el.removeAttribute('aria-label');
    }
    if (!text) return;
    const [before, after = ''] = parts.label.split('\u0000');
    const line = parts.p ? [before, Object.assign(document.createElement('strong'), { textContent: parts.amount }), after] : [parts.label];
    const sub = el.querySelector('.vhp-swipe-card__foryou-sub');
    if (sub) {
      if (sub.dataset.ask == null) sub.dataset.ask = sub.textContent;
      if (parts.slots) sub.replaceChildren(...parts.meta.split('\u0001').flatMap((bit, i) => (i ? [slotChip(), bit] : [bit])));
      else sub.textContent = sub.dataset.ask;
    } else if (parts.slots) line.push(` · ${parts.meta.replaceAll('\u0001', '?')}`);
    text.replaceChildren(...line);
  };
  const paintForYou = (overlay, ns, card) => {
    const btn = $(overlay, '[data-vhp-swipe-foryou]');
    const el = ns === 'swipe' ? btn : $(overlay, '[data-vhp-swipe-under-foryou]');
    if (!btn || !el) return;
    faceCards.set(overlay, { ...(faceCards.get(overlay) || {}), [ns]: card });
    const parts = forYouParts(overlay, card);
    if (!parts) return;
    writeForYou(el, ns === 'swipe' ? $(btn, '[data-vhp-swipe-foryou-text]') : el, parts);
    if (ns === 'swipe' && parts.p) plannerEvents('step', 'portion_seen', 'card');
  };
  // Reel layout: the face of the slide under the front card (a copy of the card, assets/vhp-reel-deck.js aheadFace):
  // its "Für dich" line, "In deinen Likes" tag and the save button's state, so the scroll reveals a finished card.
  const aheadCards = new WeakMap(); // ahead face element → its dish, so a new target repaints it too
  const paintAheadFace = (overlay, el, card) => {
    aheadCards.set(el, card);
    const api = likesApi();
    const parts = forYouParts(overlay, card);
    const line = el.querySelector('.vhp-swipe-card__foryou');
    if (line && parts) writeForYou(line, line.querySelector('.vhp-swipe-card__foryou-text'), parts);
    const on = Boolean(api) && isLiked(api, card);
    const tag = el.querySelector('.vhp-swipe-card__liked');
    if (tag) tag.hidden = !on;
    paintCta(el.querySelector('.vhp-reel-cta'), on);
  };
  const repaintForYou = (overlay) => {
    const cards = faceCards.get(overlay) || {};
    paintForYou(overlay, 'swipe', cards.swipe);
    paintForYou(overlay, 'swipe-under', cards['swipe-under']);
    overlay.querySelectorAll('.is-ahead').forEach((el) => {
      if (aheadCards.has(el)) paintAheadFace(overlay, el, aheadCards.get(el));
    });
  };

  // The calculator for the card on top (its "Für dich" line): the recipe calculator in a sheet, with this dish.
  const calcSheet = (overlay) => $(overlay, '[data-vhp-card-calc-sheet]');
  const openCardCalc = (overlay, state, dish) => {
    const sheet = calcSheet(overlay);
    const wrap = sheet && $(sheet, '[data-vhp-card-calc]');
    const root = wrap && $(wrap, '[data-vhp-calc]');
    const card = dish || onScreen(state);
    if (!root || !card || card.native || state.calcOpen) return;
    reelSignal(state, card, 'recipe_opened', true);
    // The dish for the plan link (vhp-plan-goal.js: liked and named first in the planner, as from a recipe).
    const keep = { plannable: 'true', productId: card.id, handle: card.handle, title: card.title, image: card.image, slot: card.slot };
    ['kcal', 'protein', 'carbs', 'fat', 'time'].forEach((key) => (keep[key] = card[key] == null ? '' : String(card[key])));
    Object.entries(keep).forEach(([key, value]) => (wrap.dataset[key] = value || ''));
    root.dataset.kcal = String(Math.round(Number(card.kcal) || 0));
    root.dataset.protein = String(Math.round(Number(card.protein) || 0));
    root.dataset.slot = card.slot;
    const title = $(sheet, '[data-vhp-card-calc-title]');
    if (title) title.textContent = card.title || '';
    const img = $(sheet, '[data-vhp-card-calc-img]');
    if (img) {
      img.hidden = !card.image;
      if (card.image) img.src = card.image;
    }
    window.vhpPortionCalc?.mount(root);
    state.calcOpen = true;
    const api = likesApi();
    if (api) paintProgress(overlay, state, api);
    state.deck.media?.querySelector('video')?.pause();
    sheet.hidden = false;
    void sheet.offsetWidth; // commit the closed position, then slide in
    sheet.classList.add('is-open');
    title?.focus({ preventScroll: true });
    window.vhpTrack?.('feed_card_calc', { slot: card.slot, known: Boolean(window.vhpPortionCalc?.day?.()) });
  };
  const closeCardCalc = (overlay, state) => {
    const sheet = calcSheet(overlay);
    if (!sheet || !state.calcOpen) return;
    state.calcOpen = false;
    sheet.classList.remove('is-open');
    window.setTimeout(() => {
      if (!state.calcOpen) sheet.hidden = true;
    }, prefersReducedMotion() ? 0 : 320);
    const video = state.deck.media?.querySelector('video');
    if (video && video.dataset.userPaused !== '1') video.play()?.catch?.(() => {});
    const api = likesApi();
    if (api) paintProgress(overlay, state, api);
  };

  const maybeLoadMore = (overlay) => {
    const state = stateByOverlay.get(overlay);
    const api = likesApi();
    if (!state || !api) return;
    const plan = deckPlan(state, api);
    const loadMoreBtn = state.root.querySelector('#loadMoreBtn');
    if (!loadMoreBtn || loadMoreBtn.disabled) return;
    const wrap = state.root.querySelector('#loadMoreWrap');
    if (wrap && wrap.style.display === 'none') return;
    if (plan.fresh && plan.cards.length > 2 && !rankGap(state, plan, api)) return;
    loadMoreBtn.click();
  };

  // Details of the visible recipe in the recipe sheet (same as tapping the title or the up arrow).
  const openDetails = (overlay, state, how, dish) => {
    const card = dish || onScreen(state);
    if (!card || card.native || !window.vhpRecipeSheet) return;
    const href = card.href || overlay.querySelector('[data-vhp-swipe-recipe]')?.getAttribute('href');
    if (!href || href === '#') return;
    window.vhpRecipeSheet.open(href);
    window.vhpTrack?.('feed_details', { how, slot: card.slot });
    reelSignal(state, card, 'recipe_opened', true);
  };

  // Native cards (intro, planner, promos: blocks of sections/vhp-home-feed.liquid) take the place of a recipe
  // card in the inline feed. They reuse the card slot: deck.card is the native card while it is
  // active, so dragging and fly-out work unchanged, and take/skip on a native card only dismiss it.
  // Keyed by block id. Timing lives in the session (swipes, cards shown, last card) so it survives going back
  // and forth between feed and recipe pages; the intro is outside the gap and the per-visit limit.
  const nativeEls = (overlay) => Array.from(overlay.querySelectorAll('[data-vhp-native]'));
  const nativeEl = (overlay, key) => overlay.querySelector('[data-vhp-native="' + key + '"]');
  const gapOk = (state) => state.session.last == null || state.session.swipes - state.session.last >= state.minGap;
  const spaced = (at, swipes) => at == null || swipes - at >= EX_SPACING;

  // Locked exclusive cards (the "exclusive" block): one card element, repainted with another exclusive recipe each
  // time from the pool (templates/collection.feed-exclusives.liquid), ranked like the deck. Own schedule and limit
  // (data-first / data-every / data-max), outside the section's card limit and gap, EX_SPACING from other cards.
  // Without the pool the server's pick shows once.
  let exPool = null; // null: not loaded (yet), []: none or failed
  let exLoading = false;
  const loadExPool = (el) => {
    if (exPool || exLoading || !el?.dataset.exPool) return;
    exLoading = true;
    fetch(el.dataset.exPool, { headers: { Accept: 'text/html' } })
      .then((response) => (response.ok ? response.text() : Promise.reject(new Error(`exclusives ${response.status}`))))
      .then((html) => {
        const holder = new DOMParser().parseFromString(html, 'text/html').querySelector('#vhpFeedExclusives');
        exPool = JSON.parse(holder?.textContent || '[]').filter((row) => row?.id && row.image);
      })
      .catch(() => {
        exPool = [];
      });
  };

  // Best ranked exclusive not shown this visit (ranked like the deck, with the visitor's taste; the loaded cards are
  // where their likes are looked up), of the slot they like most first, preferring one not shown on this device
  // for EX_FRESH_DAYS.
  const nextExclusive = (state) => {
    if (!exPool?.length) return null;
    const shown = new Set(state.session.exIds);
    let left = exPool.filter((row) => !shown.has(row.id));
    if (!left.length) return null;
    const order = window.vhpDeckOrder;
    if (order) {
      const taste = order.browserTaste();
      left = order.rank(left, {
        stats: order.pageStats(),
        seed: order.seed(order.browserSeed(), 'deck'),
        now: Date.now(),
        taste: taste && { ...taste, cards: state.sources },
      }).cards;
      const fav = order.favouriteSlot(likesApi()?.read().likes.items);
      if (fav) left = [...left.filter((row) => row.slot === fav), ...left.filter((row) => row.slot !== fav)];
    }
    const seen = readJson(EX_SEEN_KEY);
    const since = Date.now() - EX_FRESH_DAYS * 86400000;
    return left.find((row) => !(Number(seen[row.id]) > since)) || left.slice().sort((a, b) => (seen[a.id] || 0) - (seen[b.id] || 0))[0];
  };

  const exclusiveDue = (el, state) => {
    const s = state.session;
    const max = Number(el.dataset.max) || 0;
    if ((max && s.ex >= max) || !spaced(s.last, s.swipes)) return false;
    if (exPool?.length) {
      if (!nextExclusive(state)) return false;
    } else if (s.ex >= 1 || !el.dataset.exId) {
      // No pool (yet, failed or empty): the server-rendered recipe, once, if the server found one.
      return false;
    }
    if (s.exLast == null) return s.swipes >= (Number(el.dataset.first) || 0);
    const every = Number(el.dataset.every) || 0;
    return every > 0 && s.swipes - s.exLast >= every;
  };

  const paintExclusive = (el, row) => {
    el.dataset.exId = row.id;
    let img = el.querySelector('.vhp-native__bg--locked');
    if (!img) {
      img = document.createElement('img');
      img.className = 'vhp-native__bg vhp-native__bg--locked';
      img.alt = '';
      el.prepend(img);
    }
    img.removeAttribute('srcset');
    img.loading = 'eager';
    img.src = row.image;
    const title = el.querySelector('[data-vhp-ex-title]');
    if (title) title.textContent = row.title;
    const cta = el.querySelector('[data-vhp-ex-cta]');
    if (cta) {
      const url = new URL(cta.href, location.href);
      url.searchParams.set('src', 'exclusive');
      url.searchParams.set('recipe', row.handle);
      cta.href = url.pathname + url.search;
    }
  };

  // Intro layout "collage" (docs/HOME_INTRO.md, snippets/vhp-feed-hero.liquid): one fast-cut recipe video behind a
  // headline, the planner button and the way into the feed. Not for visitors whose likes already make a plan or who
  // started a setup; otherwise the block's once-per-device / per-visit rule applies like for the other intro layouts.
  const HERO_BUILT_SCREENS = new Set(['preview', 'subscribe', 'reviews']);
  const plannerStarted = (api) => {
    const saved = readJson(api?.STORAGE_KEY || 'vhp_planner_anon');
    return Boolean(saved && (saved.goal || HERO_BUILT_SCREENS.has(saved.screen)));
  };
  const heroWanted = (introEl, api) => {
    if (!introEl || introEl.dataset.introLayout !== 'collage') return true;
    return Boolean(api) && !api.planReady() && !plannerStarted(api);
  };

  // "Deine Portion" slide (docs/PORTION_FIRST.md 10, block "portion" in sections/vhp-home-feed.liquid): due right
  // after her first save of the visit (about the dish she saved), else after n cards (the dish she saw last); only
  // for visitors without a portion target, once per device while none is known (PORTION_SLIDE_KEY, 60 days), two
  // cards away from the other native cards. Painted with window.vhpPortionCalc (answers / choose / adjust,
  // assets/vhp-plan-goal.js); the ingredient lines come from the dish's recipe sheet.
  const PORTION_SLIDE_KEY = 'vhp_portion_slide_v1';
  const PORTION_SLIDE_DAYS = 60;
  const likeCount = () => {
    try {
      const likes = likesApi()?.read?.()?.likes;
      return Array.isArray(likes) ? likes.length : Array.isArray(likes?.items) ? likes.items.length : 0;
    } catch (e) {
      return 0;
    }
  };
  const portionKnown = () => Boolean(window.vhpPortionCalc?.day?.());
  const portionSlideSeen = () => {
    const at = Number(readJson(PORTION_SLIDE_KEY)?.at) || 0;
    return at > 0 && Date.now() - at < PORTION_SLIDE_DAYS * 864e5;
  };
  const portionDue = (overlay, el, s, state) => {
    if (state.portionLikesAtStart == null) state.portionLikesAtStart = likeCount();
    if (overlay.dataset.vhpPlannerPaid === 'true' || !window.vhpPortionCalc?.answers) return false;
    if (portionKnown() || portionSlideSeen() || s.cards[el.dataset.vhpNative] != null) return false;
    if (s.last != null && s.swipes - s.last < 2) return false;
    const saved = el.dataset.afterSave === 'true' && likeCount() > state.portionLikesAtStart;
    if (!saved && s.swipes < (Number(el.dataset.first) || 0)) return false;
    const front = onScreen(state);
    if (front && !front.native) state.portionDish = front;
    return Boolean(state.portionDish);
  };
  const portionT = (box, p) => fillT(p.scale <= 1 ? box.dataset.tOne : box.dataset.tOther, { n: p.amount });
  const portionCmp = (box, key, text) => {
    const cell = $(box, '[data-vhp-portion-cmp="' + key + '"]');
    if (!cell) return;
    cell.textContent = text;
    cell.hidden = !text;
  };
  // The dish's kcal against hers: "?" until she has answered (nothing is assumed, docs/PORTION_FIRST.md 11), then her
  // kcal, protein and portion.
  const paintPortionCompare = (box, dish, p) => {
    // Her tile is a button: the questions while "?", Anpassen once answered.
    const you = $(box, '[data-vhp-portion-you]');
    if (you) {
      you.classList.toggle('is-known', Boolean(p));
      you.toggleAttribute('data-vhp-portion-go', !p);
      you.toggleAttribute('data-vhp-portion-adjust', Boolean(p));
    }
    portionCmp(box, 'kcal_a', Math.round(Number(dish.kcal) || 0) + ' kcal');
    portionCmp(box, 'protein_a', Math.round(Number(dish.protein) || 0) + ' g Protein');
    portionCmp(box, 'kcal_b', p ? p.kcal + ' kcal' : '?');
    portionCmp(box, 'protein_b', p ? p.protein + ' g Protein' : '');
    portionCmp(box, 'portion_b', p ? portionT(box, p) : '');
  };
  const paintPortionCard = (overlay, el, state) => {
    const box = $(el, '[data-vhp-portion]');
    const dish = state.portionDish;
    if (!box || !window.vhpPortionCalc?.answers || !dish) return;
    const img = $(box, '[data-vhp-portion-img]');
    if (img) {
      img.hidden = !dish.image;
      if (dish.image && img.getAttribute('src') !== dish.image) img.src = dish.image;
    }
    const title = $(box, '[data-vhp-portion-title]');
    if (title) title.textContent = dish.title || '';
    paintPortionCompare(box, dish, null);
    const ask = $(box, '[data-vhp-portion-ask]');
    const done = $(box, '[data-vhp-portion-done]');
    if (ask) ask.hidden = false;
    if (done) done.hidden = true;
  };
  const paintPortionDone = (box, dish, goal, p, body) => {
    const d = box.dataset;
    const goalKey = 'tGoal' + goal.charAt(0).toUpperCase() + goal.slice(1);
    const pill = $(box, '[data-vhp-portion-done-pill]');
    if (pill) pill.textContent = fillT(d.tDonePill, { goal: d[goalKey] || goal, weight: body.weight });
    paintPortionCompare(box, dish, p);
    const ask = $(box, '[data-vhp-portion-ask]');
    const done = $(box, '[data-vhp-portion-done]');
    if (ask) ask.hidden = true;
    if (done) done.hidden = false;
  };
  const activePortion = (overlay, state) => {
    const el = state?.nativeActive ? nativeEl(overlay, state.nativeActive) : null;
    return el && el.dataset.nativeType === 'portion' ? $(el, '[data-vhp-portion]') : null;
  };
  const portionChosen = (overlay, state, goal) => {
    const box = activePortion(overlay, state);
    const dish = state.portionDish;
    const calc = window.vhpPortionCalc;
    if (!box || !dish || !calc?.choose) return;
    const res = calc.choose(goal, dish, 'deck');
    if (!res?.portion) return;
    state.portionGoal = goal;
    navigator.vibrate?.(10);
    paintPortionDone(box, dish, goal, res.portion, res.body);
  };
  // A target worked out elsewhere while the slide is up (Anpassen → the card calculator's weight step): the slide
  // shows the done state with the new numbers.
  const repaintPortion = (overlay, state) => {
    const box = activePortion(overlay, state);
    const dish = state.portionDish;
    const calc = window.vhpPortionCalc;
    if (!box || !dish || !calc?.day?.()) return;
    const goal = calc.day().goal || state.portionGoal || 'lose';
    const p = calc.portion(dish);
    if (p) paintPortionDone(box, dish, goal, p, calc.answers(dish).body);
  };

  // ahead: look one pass ahead (the reel layout paints the slide under the front card with what comes next).
  const pickNative = (overlay, state, ahead = 0) => {
    if (!state.inline) return null;
    if (state.nativeActive) return ahead ? null : state.nativeActive;
    const els = nativeEls(overlay);
    if (state.introPending) {
      const intro = els.find((el) => el.dataset.nativeType === 'intro');
      if (intro) return intro.dataset.vhpNative;
      state.introPending = false;
    }
    const s = ahead ? { ...state.session, swipes: state.session.swipes + ahead } : state.session;
    const budget = s.shown < state.maxPerVisit && (s.last == null || s.swipes - s.last >= state.minGap) && spaced(s.exLast, s.swipes);
    // "Show when ready": the like that makes the plan ready (3 likes incl. a main) is when the planner pitch
    // lands best. Only that transition, not visitors who arrive already ready.
    const ready = !state.readyAtStart && Boolean(likesApi()?.planReady());
    for (const el of els) {
      if (el.dataset.nativeType === 'intro') continue;
      if (el.dataset.nativeType === 'portion') {
        if (portionDue(overlay, el, s, state)) return el.dataset.vhpNative;
        continue;
      }
      // Two cards between the portion slide and any other native card.
      if (state.portionAt != null && s.swipes - state.portionAt < 2) continue;
      if (el.dataset.nativeType === 'exclusive') {
        loadExPool(el);
        if (exclusiveDue(el, { ...state, session: s })) return el.dataset.vhpNative;
        continue;
      }
      if (!budget) continue;
      const at = s.cards[el.dataset.vhpNative];
      const every = Number(el.dataset.every) || 0;
      if (at == null) {
        if (s.swipes >= (Number(el.dataset.first) || 0) || (ready && el.dataset.ready === 'true')) return el.dataset.vhpNative;
      } else if (every > 0 && s.swipes - at >= every) {
        return el.dataset.vhpNative;
      }
    }
    return null;
  };

  // What the deck shows under the front card. Reel layout: the native card due on the next pass (as a poster), so
  // the slide she scrolls onto is what she gets; else the next recipe.
  const nextPeek = (overlay, state, cards) => {
    if (!state.reel) return cards[1] || null;
    if (state.nativeActive) return cards[0] || null;
    const key = pickNative(overlay, state, 1);
    const el = key ? nativeEl(overlay, key) : null;
    if (!el) return cards[1] || null;
    // The copy under the front card shows the card as it will be: painted now, again when it shows.
    const api = likesApi();
    if (el.dataset.nativeType === 'planner' && api) paintPlannerCard(el, api, state);
    // The portion slide's dish (photo, title, kcal): otherwise the copy is the empty template and the photo only
    // starts loading once she is on it.
    if (el.dataset.nativeType === 'portion') paintPortionCard(overlay, el, state);
    if (el.dataset.nativeType === 'exclusive') {
      const row = nextExclusive(state);
      if (row) paintExclusive(el, row);
    }
    return { native: true, el };
  };

  // Planner card: Mo–Fr strip and copy from the visitor's own likes (same weekView as the swipe dock). Reel layout:
  // her saved dishes as a row of photos (the picks are taste, not the menu: docs/DISH_PICKER.md 5) and the copy
  // says what happens next, in his words.
  const paintPlannerCard = (el, api, state) => {
    const doc = api.read();
    const view = api.weekView(doc);
    const n = api.likeCount(doc);
    const week = el.querySelector('[data-vhp-planner-week]');
    if (week && state?.reel) {
      const picks = api.likeItems(doc).slice(-5).reverse();
      week.classList.toggle('is-picks', picks.length > 0);
      week.replaceChildren(
        ...picks.map((item) => {
          const pick = document.createElement('div');
          pick.className = 'vhp-native__pick';
          pick.setAttribute('role', 'listitem');
          pick.title = item.title || '';
          if (item.image) {
            const img = document.createElement('img');
            img.src = item.image;
            img.alt = '';
            img.width = 64;
            img.height = 64;
            pick.append(img);
          }
          return pick;
        })
      );
      const titleEl = el.querySelector('[data-vhp-planner-title]');
      const textEl = el.querySelector('[data-vhp-planner-text]');
      const ctaEl = el.querySelector('[data-vhp-planner-cta]');
      const left = Number(view.readyLeft) || 0;
      if (titleEl) titleEl.innerHTML = n > 0 ? tr('reels.reel_title_html') : tr('reels.intro_title_html');
      if (textEl) {
        textEl.textContent =
          n === 0
            ? tr('reels.reel_intro_text')
            : view.ready
              ? tr('reels.reel_ready_text', { count: n })
              : view.needMain && left <= 1
                ? tr('reels.reel_forming_main')
                : tr('reels.reel_forming_text', { n: left });
      }
      if (ctaEl) ctaEl.textContent = tr('reels.reel_cta');
      return;
    }
    if (week) {
      week.replaceChildren(
        ...view.slots.map((slot) => {
          const day = document.createElement('div');
          day.className = 'vhp-native__day is-' + slot.state;
          day.setAttribute('role', 'listitem');
          if (slot.item) day.title = slot.item.title;
          const dot = document.createElement('span');
          dot.className = 'vhp-native__dot';
          if (slot.item?.image) {
            const img = document.createElement('img');
            img.src = slot.item.image;
            img.alt = '';
            img.width = 64;
            img.height = 64;
            dot.append(img);
          }
          const name = document.createElement('span');
          name.textContent = slot.day;
          day.append(dot, name);
          return day;
        })
      );
    }
    let title = tr('reels.intro_title_html');
    let text = tr('reels.intro_text');
    let cta = tr('reels.intro_cta');
    if (view.filled >= view.goal) {
      title = tr('reels.full_title_html');
      text = tr('reels.full_text', { n, goal: view.goal });
      cta = tr('reels.full_cta');
    } else if (n > 0) {
      title = tr('reels.forming_title_html');
      text = view.filled
        ? tr('reels.forming_text', { filled: view.filled, goal: view.goal })
        : tr('reels.saved_text', { n });
      cta = tr('reels.forming_cta');
    }
    const titleEl = el.querySelector('[data-vhp-planner-title]');
    const textEl = el.querySelector('[data-vhp-planner-text]');
    const ctaEl = el.querySelector('[data-vhp-planner-cta]');
    if (titleEl) titleEl.innerHTML = title;
    if (textEl) textEl.textContent = text;
    if (ctaEl) ctaEl.textContent = cta;
  };

  // "Sören talks" intro (intro block, layout talk; snippets/vhp-feed-native-card.liquid): his intro video plays on a loop,
  // muted with its own captions. Progress line, sound button; the solid button pops once more when he's done. Watch
  // milestones go to feed_intro_progress, the sound button to feed_intro_sound; the dismiss carries sec and done.
  const talkWired = new WeakSet();
  const wireTalk = (el, state) => {
    if (talkWired.has(el)) return;
    talkWired.add(el);
    const video = el.querySelector('.vhp-talk__video');
    const bar = el.querySelector('[data-vhp-talk-progress]');
    const sound = el.querySelector('[data-vhp-talk-sound]');
    const label = el.querySelector('[data-vhp-talk-label]');
    if (!video) return;
    const marks = new Set();
    const mark = (p) => {
      if (marks.has(p) || state.nativePreview) return;
      marks.add(p);
      window.vhpTrack?.('feed_intro_progress', { p });
    };
    const paintSound = () => {
      const on = !video.muted;
      el.classList.toggle('is-sound', on);
      sound?.setAttribute('aria-pressed', String(on));
      if (label && sound) label.textContent = on ? sound.dataset.labelOff : sound.dataset.labelOn;
    };
    sound?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      video.muted = !video.muted;
      if (video.paused && !video.ended) video.play()?.catch?.(() => {});
      paintSound();
      if (!state.nativePreview) window.vhpTrack?.('feed_intro_sound', { on: !video.muted, sec: Math.round(video.currentTime) });
    });
    video.addEventListener('timeupdate', () => {
      const p = video.duration ? video.currentTime / video.duration : 0;
      if (bar) bar.style.transform = 'scaleX(' + p.toFixed(3) + ')';
      [25, 50, 75].forEach((m) => {
        if (p * 100 >= m) mark(m);
      });
    });
    video.addEventListener('ended', () => {
      if (bar) bar.style.transform = 'scaleX(1)';
      el.classList.add('is-done');
      mark(100);
      if (!state.nativePreview && el.dataset.nativeType === 'intro') plannerEvents('step', 'intro_card', 'done');
      // and round again (the button already popped; done stays for the dismiss event)
      video.currentTime = 0;
      video.play()?.catch?.(() => {});
    });
    // Never talk from a hidden browser tab (the app's own tabs detach the feed, which pauses and resumes it).
    let resume = false;
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        resume = !video.paused;
        if (resume) video.pause();
      } else if (resume && !el.hidden) {
        resume = false;
        video.play()?.catch?.(() => {});
      }
    });
    paintSound();
  };

  const showNative = (overlay, state, api, key, cards) => {
    const el = nativeEl(overlay, key);
    if (!el) return;
    const type = el.dataset.nativeType;
    if (type === 'planner') paintPlannerCard(el, api, state);
    if (type === 'portion') paintPortionCard(overlay, el, state);
    const empty = $(overlay, '[data-vhp-reel-empty]');
    const actions = $(overlay, '[data-vhp-swipe-actions]');
    const hintEl = $(overlay, '[data-vhp-swipe-hint]');
    const fresh = state.nativeActive !== key;
    if (fresh) {
      state.nativeActive = key;
      if (type === 'exclusive') {
        const row = nextExclusive(state);
        if (row) paintExclusive(el, row);
      }
      // Theme editor preview (block selected) doesn't count against the visit.
      if (type === 'exclusive' && !state.nativePreview) {
        const s = state.session;
        s.ex += 1;
        s.exLast = s.swipes;
        if (el.dataset.exId) {
          s.exIds.push(el.dataset.exId);
          const seen = readJson(EX_SEEN_KEY);
          seen[el.dataset.exId] = Date.now();
          writeJson(EX_SEEN_KEY, seen);
        }
        saveSession(s);
      } else if (type === 'portion' && !state.nativePreview) {
        // Once per visit and per device (while no target is known); not counted against the visit's budget, the
        // 2-card gap to the other natives is pickNative's.
        const s = state.session;
        s.cards[key] = s.swipes;
        saveSession(s);
        state.portionAt = s.swipes;
        writeJson(PORTION_SLIDE_KEY, { at: Date.now() });
        plannerEvents('step', 'calc_use', 'seen_deck');
      } else if (type !== 'intro' && !state.nativePreview) {
        const s = state.session;
        s.shown += 1;
        s.last = s.swipes;
        s.cards[key] = s.swipes;
        saveSession(s);
      } else if (type === 'intro' && !state.nativePreview) {
        state.introShownAt = Date.now();
        plannerEvents('step', 'intro_card', 'shown');
      }
      window.vhpTrack?.('feed_native_shown', { card: el.dataset.nativeName || type, recipe: el.dataset.exId || undefined });
    }
    // Before the card's own play(): the reel deck's pause() stops every video in its track, this card's included.
    state.deck.pause();
    const video = el.querySelector('video');
    if (video) {
      if (el.classList.contains('vhp-native--talk')) {
        // Plays once from the start; a repaint of the deck keeps it running with the visitor's sound choice.
        wireTalk(el, state);
        if (fresh) {
          video.currentTime = 0;
          el.classList.remove('is-done');
          delete el.dataset.how;
        }
      } else {
        video.muted = true;
      }
      if (!video.ended) video.play()?.catch?.(() => {});
    }
    state.deck.realCard.hidden = true;
    el.hidden = false;
    state.deck.useCard(el);
    state.current = { native: true, id: 'native:' + key, key };
    if (empty) empty.hidden = true;
    if (actions) actions.hidden = true;
    if (hintEl) hintEl.hidden = true;
    overlay.removeAttribute('data-has-video');
    fillPeek(state, cards[0] || null);
    if (!state.deck.dragging) state.deck.reset();
    paintProgress(overlay, state, api);
  };

  const dismissNative = (overlay, state, how) => {
    const key = state.nativeActive;
    if (!key) return;
    const el = state.deck.card;
    el.hidden = true;
    el.style.transform = '';
    el.style.opacity = '';
    el.style.transition = '';
    const video = el.querySelector('video');
    video?.pause();
    const talk = el.classList.contains('vhp-native--talk');
    state.deck.useCard(null);
    state.nativeActive = null;
    state.current = null;
    if (el.dataset.nativeType === 'intro') {
      state.introPending = false;
      if (!state.nativePreview) {
        if (el.dataset.onceDevice === 'true') setFlag(introKey(el));
        state.session.intro = true;
        saveSession(state.session);
        // How long the intro held them before they moved on (button or swipe), in buckets.
        if (state.introShownAt) plannerEvents('step', 'intro_card', introSeconds((Date.now() - state.introShownAt) / 1000));
      }
    }
    // A right swipe on an exclusive: remembered for the planner (docs/FEED_ORDER.md step 4).
    if (how === 'right' && el.dataset.nativeType === 'exclusive' && el.dataset.exId && !state.nativePreview) {
      const wants = readJson(EX_WANT_KEY);
      wants[el.dataset.exId] = Date.now();
      writeJson(EX_WANT_KEY, wants);
    }
    window.vhpTrack?.('feed_native_dismiss', {
      card: el.dataset.nativeName || el.dataset.nativeType,
      how: el.dataset.how || how || 'button',
      recipe: el.dataset.nativeType === 'exclusive' ? el.dataset.exId : undefined,
      sec: talk && video ? Math.round(video.currentTime) : undefined,
      done: talk ? el.classList.contains('is-done') : undefined,
    });
  };

  // "Alles gesehen": the homepage feed ran out of new recipes. Shown once per feed tab (and filter state) and
  // catalog size, so it comes back only after new recipes arrived and were seen too. The deck underneath
  // already holds the first card of the rotation (paused until "Weiter swipen").
  const FAN = [-16, -8, 0, 8, 16];
  const doneEl = (overlay) => $(overlay, '[data-vhp-feed-done]');

  // Planner note on the "Alles gesehen" screen, worked out from the visitor's likes (Mo–Fr = WEEK_MAINS mains a
  // week): a fact about their own collection plus a text link, no extra button. Hidden until the likes make a plan.
  const paintDonePlan = (overlay, el) => {
    const note = $(el, '[data-vhp-done-plan]');
    const api = likesApi();
    if (!note || !api) return;
    const doc = api.read();
    const paid = overlay.dataset.vhpPlannerPaid === 'true';
    const mains = doc.likes.items.filter((item) => item.slot === 'main').length;
    const weeks = Math.floor(mains / (api.WEEK_MAINS || 5));
    let text = '';
    let cta = tr('reels.done_plan_cta');
    if (paid) {
      text = tr('reels.done_paid_text');
      cta = tr('reels.done_paid_cta');
    } else if (weeks >= 2) {
      text = tr('reels.done_weeks', { mains, weeks });
    } else if (weeks === 1) {
      text = tr('reels.done_week', { mains });
    } else if (api.planReady(doc)) {
      text = tr('reels.done_ready');
    }
    note.hidden = !text;
    if (!text) return;
    $(note, '[data-vhp-done-plan-text]').textContent = text;
    $(note, '[data-vhp-done-plan-cta]').textContent = cta;
    note.href = overlay.dataset.vhpPlannerUrl || '/pages/meal-planner';
  };

  const openDone = (overlay, state, plan) => {
    const el = doneEl(overlay);
    const mode = state.root.dataset.feedMode || 'alle-rezepte';
    if (!el || state.doneOpen || state.nativePreview || mode === 'explore-set') return;
    if (window.vhpSwipeWeek?.holding?.(overlay)) return;
    const filtered = Boolean(window.vhpFeed?.hasFilters?.());
    const key = mode + (filtered ? '|filter' : '');
    const total = plan.seen.length;
    const shown = readJson(DONE_KEY);
    if (shown[key] === total) return;
    shown[key] = total;
    writeJson(DONE_KEY, shown);

    paintDonePlan(overlay, el);
    const likedHere = plan.seen.filter((card) => plan.liked.has(card.id));
    const tab = document.querySelector(`[data-feed-handle="${CSS.escape(mode)}"]`);
    const label = tab && mode !== 'alle-rezepte' ? tab.textContent.trim() : '';
    const likes = likedHere.length ? tr('reels.done_liked', { n: likedHere.length }) : '';
    let title = tr('reels.done_title_html');
    // The planner note already leads to the likes; then no separate "Meine Likes" button.
    let alt = likedHere.length && $(el, '[data-vhp-done-plan]')?.hidden !== false ? 'likes' : '';
    if (filtered) {
      title = tr('reels.done_filters_title_html');
      alt = 'filters';
    } else if (label) {
      title = tr('reels.done_set_title_html', { label });
      alt = 'all';
    }
    $(el, '[data-vhp-done-title]').innerHTML = title;
    $(el, '[data-vhp-done-copy]').textContent =
      tr('reels.done_copy', { n: total, likes });
    const altBtn = $(el, '[data-vhp-done-alt]');
    altBtn.hidden = !alt;
    altBtn.dataset.vhpDoneAlt = alt;
    altBtn.textContent = { likes: tr('reels.alt_likes'), filters: tr('reels.alt_filters'), all: tr('reels.alt_all') }[alt] || '';

    const fan = $(el, '[data-vhp-done-fan]');
    const faces = (likedHere.length ? likedHere : plan.seen).filter((card) => card.image).slice(-5);
    fan.replaceChildren(
      ...faces.map((card, i) => {
        const face = document.createElement('span');
        face.className = 'vhp-sw-fan__card';
        face.style.setProperty('--rot', `${FAN[i + Math.floor((5 - faces.length) / 2)]}deg`);
        face.style.setProperty('--i', String(i));
        const img = document.createElement('img');
        img.alt = '';
        img.src = card.image;
        face.append(img);
        return face;
      })
    );

    state.doneOpen = true;
    const reduced = prefersReducedMotion();
    el.classList.toggle('is-reduced', reduced);
    el.hidden = false;
    if (reduced) el.classList.add('is-on');
    else requestAnimationFrame(() => el.classList.add('is-on'));
    $(el, '[data-vhp-done-go]')?.focus({ preventScroll: true });
    window.vhpTrack?.('feed_all_seen', { mode, filtered, n: total, likes: likedHere.length });
  };

  const closeDone = (overlay, state) => {
    const el = doneEl(overlay);
    if (!el || !state.doneOpen) return;
    state.doneOpen = false;
    el.classList.remove('is-on');
    el.hidden = true;
    const video = state.deck.media?.querySelector('video');
    if (video && video.dataset.userPaused !== '1') video.play()?.catch?.(() => {});
  };

  const showDeck = (overlay, state, api) => {
    const plan = deckPlan(state, api);
    const cards = plan.cards;
    const empty = $(overlay, '[data-vhp-reel-empty]');
    const actions = $(overlay, '[data-vhp-swipe-actions]');
    const hintEl = $(overlay, '[data-vhp-swipe-hint]');
    const cardEl = state.deck.card;

    renderMeter(overlay, state, api);

    // Reel layout, repaint after a like at the front: the card she just liked stays; a native card that is due now
    // (the planner card once the plan is ready) comes as the next slide (nextPeek), not in place of it.
    const hold = Boolean(state.holdFront);
    state.holdFront = false;
    const nativeKey = hold ? null : pickNative(overlay, state);
    if (nativeKey) {
      showNative(overlay, state, api, nativeKey, cards);
      return;
    }

    // Nothing loaded yet: fetch the next page right away (loader, no message). The grid observer re-runs
    // this when the cards land; the timer covers a failed or empty fetch. With swiped recipes loaded the deck
    // never waits: it shows the rotation and a new recipe slots in behind the top card once it arrives (keepTop).
    if (!cards.length && canLoadMore(state)) {
      state.deck.pause();
      cardEl.hidden = true;
      fillPeek(state, null);
      if (empty) empty.hidden = true;
      if (actions) actions.hidden = true;
      overlay.classList.add('is-deck-waiting');
      paintProgress(overlay, state, api);
      maybeLoadMore(overlay);
      window.clearTimeout(state.waitTimer);
      state.waitTimer = window.setTimeout(() => showDeck(overlay, state, api), 4000);
      return;
    }
    window.clearTimeout(state.waitTimer);
    overlay.classList.remove('is-deck-waiting');

    if (!cards.length) {
      state.deck.pause();
      cardEl.hidden = true;
      fillPeek(state, null);
      if (empty) {
        empty.hidden = false;
        const copy = $(overlay, '[data-vhp-reel-empty-copy]');
        if (copy) {
          copy.textContent = window.vhpFeed?.hasFilters?.()
            ? tr('reels.empty_filtered')
            : tr('reels.empty_more');
        }
      }
      if (actions) actions.hidden = true;
      overlay.removeAttribute('data-has-video');
      paintProgress(overlay, state, api);
      return;
    }

    cardEl.hidden = false;
    if (empty) empty.hidden = true;
    if (actions) actions.hidden = false;

    const doc = api.read();
    // A recipe article landing (docs/RECIPE_FUNNEL.md 0.3) came for this recipe: its own card gets no swipe tutorial
    // over the title, so the peek "Zutaten & Zubereitung" is the obvious next step. The hint waits for another card.
    const entryCard = document.querySelector('[data-vhp-feed][data-entry-card]')?.dataset.entryCard || '';
    // Reel layout: no swipe tutorial (the deck shows a one-time "swipe up" nudge instead).
    const hint = !state.reel && !doc.swipeHintSeen && !prefersReducedMotion() && !(entryCard && String(cards[0].id) === entryCard);
    if (hintEl) hintEl.hidden = !hint;
    cardEl.classList.toggle('is-hinting', hint);

    const undoBtn = overlay.querySelector('[data-vhp-swipe="undo"]');
    if (undoBtn) undoBtn.disabled = !doc.undo && !state.seenUndo;

    if (!plan.fresh && state.inline && !canLoadMore(state)) openDone(overlay, state, plan);
    fillCard(overlay, state, cards[0]);
    fillPeek(state, nextPeek(overlay, state, cards));
    paintLiked(overlay, plan.liked.has(cards[0].id));
    // Lets the recipe sheet prefetch the current + next two recipes (assets/vhp-recipe-sheet.js).
    overlay.dispatchEvent(
      new CustomEvent('vhp:deck-card', { bubbles: true, detail: { hrefs: cards.slice(0, 3).map((c) => c.href) } })
    );
    if (state.doneOpen || window.vhpSwipeWeek?.holding?.(overlay)) {
      overlay.querySelectorAll('[data-vhp-swipe-media] video').forEach((video) => {
        try { video.pause(); } catch (e) { /* ignore */ }
      });
    }
    if (!state.deck.dragging) state.deck.reset();
    paintProgress(overlay, state, api);
    maybeLoadMore(overlay);
  };

  // Cards landed while a recipe is on top: it stays (no video restart), the new ones line up behind it. A new
  // recipe found behind a rotation card is the very next one. False when the deck has to repaint instead.
  const keepTop = (overlay, state, api) => {
    const top = state.current;
    if (!top || top.native || state.nativeActive || state.deck.card.hidden) return false;
    state.pin = top.id;
    const plan = deckPlan(state, api);
    if (plan.cards[0]?.id !== top.id) return false;
    fillPeek(state, nextPeek(overlay, state, plan.cards));
    overlay.dispatchEvent(
      new CustomEvent('vhp:deck-card', { bubbles: true, detail: { hrefs: plan.cards.slice(0, 3).map((c) => c.href) } })
    );
    if (!plan.fresh && state.inline && !canLoadMore(state)) openDone(overlay, state, plan);
    maybeLoadMore(overlay);
    return true;
  };

  // Bookkeeping for both swipe directions. Returns what the card was before: 'liked', 'skipped' or ''.
  const countSwipe = (state, api, card) => {
    const doc = api.read();
    let before = '';
    if (doc.likes.items.some((row) => row.id === card.id)) before = 'liked';
    else if (doc.skips.items.some((row) => row.id === card.id)) before = 'skipped';
    state.swipeCount += 1;
    state.session.swipes += 1;
    saveSession(state.session);
    markSeen(card.id);
    if (before === 'liked') {
      state.revisited.add(card.id);
      state.sinceRevisit = 0;
      state.sinceSkipped += 1;
    } else if (before === 'skipped') {
      state.sinceSkipped = 0;
    } else if (!before) {
      state.sinceRevisit += 1;
    }
    state.pin = null;
    state.deferId = null;
    state.seenUndo = null;
    return before;
  };

  // A recipe seen before keeps what it had: the like stays in place (its position decides the week) and so does
  // the skip. The card only moves to the back of the rotation; undo just brings it back (state.seenUndo).
  const swipeAgain = (overlay, state, api, card) => {
    api.patch((raw) => {
      raw.undo = null;
      raw.swipeHintSeen = true;
    });
    state.seenUndo = card.id;
    state.deferId = card.id;
    showDeck(overlay, state, api);
  };

  // Taste (assets/vhp-deck-order.js opts.taste): the ranking runs again after TASTE_AT swipes of the visit and every
  // TASTE_EVERY after, with the likes and skips since; the recipe on top stays (keepTop). Without the feed index
  // rankSources already ranks with them on every grid change.
  const TASTE_AT = 5;
  const TASTE_EVERY = 10;
  const retaste = (overlay, state, api) => {
    const n = state.session.swipes;
    if (n >= TASTE_AT && (n - TASTE_AT) % TASTE_EVERY === 0) requestRanking(overlay, state, api, true);
  };

  const take = (overlay, state, api) => {
    const card = state.current;
    if (!card) return;
    if (card.native) {
      dismissNative(overlay, state, 'right');
      showDeck(overlay, state, api);
      return;
    }
    const before = countSwipe(state, api, card);
    window.vhpTrack?.('feed_swipe', { direction: 'right', slot: card.slot, n: state.swipeCount, surface: state.inline ? 'feed' : 'reel', again: Boolean(before) });
    if (before === 'liked') {
      swipeAgain(overlay, state, api, card);
      return;
    }
    const item = asLike(card, api);
    if (!item) return;
    api.patch((raw) => {
      raw.likes.items = raw.likes.items.filter((row) => row.id !== item.id);
      raw.likes.items.push(item);
      raw.skips.items = raw.skips.items.filter((row) => row.id !== item.id);
      raw.undo = { action: 'like', item };
      raw.swipeHintSeen = true;
    });
    if (typeof window.vhpTrack === 'function') {
      window.vhpTrack('reel_like', { recipe_url: card.href || '', slot: card.slot });
    }
    plannerEvents('track', 'recipe_liked', { id: card.id, slot: card.slot, src: statsSrc(state) });
    showDeck(overlay, state, api);
    retaste(overlay, state, api);
  };

  const skip = (overlay, state, api) => {
    const card = state.current;
    if (!card) return;
    if (card.native) {
      dismissNative(overlay, state, 'left');
      showDeck(overlay, state, api);
      return;
    }
    const before = countSwipe(state, api, card);
    window.vhpTrack?.('feed_swipe', { direction: 'left', slot: card.slot, n: state.swipeCount, surface: state.inline ? 'feed' : 'reel', again: Boolean(before) });
    const renew = before === 'skipped' && staleSkip(api.read().skips.items.find((row) => row.id === card.id));
    if (before && !renew) {
      swipeAgain(overlay, state, api, card);
      return;
    }
    api.patch((raw) => {
      raw.skips.items = raw.skips.items.filter((row) => row.id !== card.id);
      raw.skips.items.push({ id: card.id, slot: card.slot, at: new Date().toISOString() });
      raw.undo = { action: 'skip', item: { id: card.id, slot: card.slot, at: new Date().toISOString() } };
      raw.swipeHintSeen = true;
    });
    state.deferId = card.id;
    if (typeof window.vhpTrack === 'function') {
      window.vhpTrack('reel_skip', { recipe_url: card.href || '', slot: card.slot });
    }
    plannerEvents('track', 'recipe_skipped', { id: card.id, slot: card.slot, src: statsSrc(state) });
    showDeck(overlay, state, api);
    retaste(overlay, state, api);
  };

  // Reel layout: she scrolled past the card at the front (assets/vhp-reel-deck.js onPass). Counted like a swipe (the
  // card is seen, the native cards' timing moves on), never a skip: a pass keeps nothing out of the plan. Left within
  // SOFT_PASS_MS and not liked: a soft skip for the taste ranking.
  const pass = (overlay, state, api, card, dwell) => {
    if (!card) return;
    if (card.native) {
      dismissNative(overlay, state, 'pass');
      showDeck(overlay, state, api);
      return;
    }
    const before = countSwipe(state, api, card);
    const soft = !before && dwell < SOFT_PASS_MS;
    if (soft) markSoftPass(card.id);
    if (dwell >= WATCHED_MS) reelSignal(state, card, 'recipe_watched');
    if (dwell >= WATCHED_LONG_MS) reelSignal(state, card, 'recipe_watched_long', true);
    window.vhpTrack?.('feed_swipe', {
      direction: 'pass',
      slot: card.slot,
      n: state.swipeCount,
      surface: 'reel',
      again: Boolean(before),
      dwell: dwellBucket(dwell),
      soft,
    });
    if (before) {
      // Seen before: keeps what it had (the like stays, the skip stays), only moves to the back.
      api.patch((raw) => {
        raw.undo = null;
        raw.swipeHintSeen = true;
      });
    }
    state.deferId = card.id;
    showDeck(overlay, state, api);
    retaste(overlay, state, api);
  };

  // Reel layout: the one button. A like keeps the card where it is (pinned at the front, no advance); a second tap
  // takes it back. On a history card the like lands on that card.
  const toggleLike = (overlay, state, api, card) => {
    if (!card || card.native) return;
    const on = !isLiked(api, card);
    const front = !state.deck.viewing;
    // Saving costs the newsletter signup once (assets/vhp-mail-signup.js gate, Maxim 2026-11-03); after it this runs again.
    if (on && window.vhpMailSignup?.gate({ recipe: card.id, at: 'reel', onSaved: () => toggleLike(overlay, state, api, card) })) return;
    if (on) {
      const item = asLike(card, api);
      if (!item) return;
      api.patch((raw) => {
        raw.likes.items = raw.likes.items.filter((row) => row.id !== item.id);
        raw.likes.items.push(item);
        raw.skips.items = raw.skips.items.filter((row) => row.id !== item.id);
        raw.undo = { action: 'like', item };
        raw.swipeHintSeen = true;
      });
      clearSoftPass(card.id);
      window.vhpTrack?.('reel_like', { recipe_url: card.href || '', slot: card.slot, surface: 'reel', history: !front });
      plannerEvents('track', 'recipe_liked', { id: card.id, slot: card.slot, src: statsSrc(state) });
      navigator.vibrate?.(10);
    } else {
      plannerEvents('retract', 'recipe_liked', card.id);
      api.patch((raw) => {
        raw.likes.items = raw.likes.items.filter((row) => row.id !== card.id);
        if (raw.undo?.action === 'like' && raw.undo.item?.id === card.id) raw.undo = null;
      });
      window.vhpTrack?.('reel_unlike', { recipe_url: card.href || '', slot: card.slot, surface: 'reel', history: !front });
    }
    if (front && state.current && !state.current.native) {
      // The card stays at the front; the deck repaints the face (same card: no video restart) and what comes next
      // (the planner card after the like that makes the plan ready).
      state.pin = card.id;
      state.deferId = null;
      state.holdFront = true;
      showDeck(overlay, state, api);
    } else {
      paintLiked(overlay, on, state.deck.viewingSlide);
      renderMeter(overlay, state, api);
      paintProgress(overlay, state, api);
    }
    if (on) retaste(overlay, state, api);
  };

  const undoSwipe = (overlay, state, api) => {
    if (state.nativeActive) dismissNative(overlay, state);
    if (state.seenUndo) {
      state.pin = state.seenUndo;
      state.seenUndo = null;
      state.deferId = null;
      showDeck(overlay, state, api);
      return;
    }
    const doc = api.read();
    const step = doc.undo;
    if (!step) return;
    if (step.action === 'like' || step.action === 'skip') {
      plannerEvents('retract', step.action === 'like' ? 'recipe_liked' : 'recipe_skipped', step.item.id);
    }
    api.patch((raw) => {
      if (step.action === 'like') {
        raw.likes.items = raw.likes.items.filter((row) => row.id !== step.item.id);
      } else if (step.action === 'skip') {
        raw.skips.items = raw.skips.items.filter((row) => row.id !== step.item.id);
      }
      raw.undo = null;
    });
    state.pin = step.item.id;
    state.deferId = null;
    showDeck(overlay, state, api);
  };

  const shareCurrent = async (overlay, state) => {
    const card = onScreen(state);
    const href = card?.href || $(overlay, '[data-vhp-swipe-recipe]')?.getAttribute('href');
    if (!href || href === '#') return;
    const url = new URL(href, window.location.origin).href;
    const title = card?.title || document.title;
    const text = title ? tr('reels.share_text', { title }) : tr('reels.share_text_plain');
    window.vhpTrack?.('recipe_share', { recipe_url: url, method: navigator.share ? 'native' : 'copy', surface: state.inline ? 'feed' : 'reel' });
    reelSignal(state, card, 'recipe_shared', true);

    if (navigator.share) {
      try {
        await navigator.share({ title, text, url });
        return;
      } catch (_) {}
    }

    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(url);
        showShareToast(tr('common.link_copied'));
        return;
      }
    } catch (_) {}

    try {
      const ta = document.createElement('textarea');
      ta.value = url;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      ta.remove();
      showShareToast(tr('common.link_copied'));
    } catch (_) {
      showShareToast(tr('reels.share_failed'));
    }
  };

  const ingestNewCards = (state, api) => {
    const live = collectSources(state.grid, api, false);
    const liveById = new Map(live.map((card) => [card.id, card]));
    const order = [];
    const seen = new Set();
    state.sources.forEach((card) => {
      const next = liveById.get(card.id);
      if (!next || seen.has(next.id)) return;
      seen.add(next.id);
      order.push(next);
    });
    live.forEach((card) => {
      if (seen.has(card.id)) return;
      seen.add(card.id);
      order.push(card);
    });
    const added = order.length > state.sources.length;
    const currentGone = Boolean(state.current && !liveById.has(state.current.id));
    state.sources = order;
    rankSources(state);
    return { added, currentGone };
  };

  // The whole feed's ranking landed: re-sort, keep the recipe on top, and fetch better ranked ones (maybeLoadMore).
  // fresh: ranked again with the swipes since (retaste).
  const requestRanking = (overlay, state, api, fresh) => {
    if (!state.ranked || !window.vhpFeed?.ranking) return;
    const token = (state.rankToken += 1);
    window.vhpFeed.ranking(state.root, { fresh }).then((result) => {
      if (!result || token !== state.rankToken || stateByOverlay.get(overlay) !== state) return;
      state.rankIds = result.ids;
      state.rank = new Map(result.ids.map((id, i) => [id, i]));
      rankSources(state);
      window.vhpTrack?.('feed_order', {
        order: result.shuffled ? 'shuffle' : 'ranked',
        n: result.ids.length,
        personal: Boolean(result.personal),
        swipes: state.session.swipes,
        front: state.front ? state.front.length : 0,
      });
      if (!overlay.classList.contains('is-open') || keepTop(overlay, state, api)) return;
      if (!state.nativeActive) showDeck(overlay, state, api);
    });
  };

  const openOverlay = (root, overlay) => {
    if (overlay.classList.contains('is-open')) return true;
    const api = likesApi();
    if (!api) return false;

    const grid = root.querySelector('#recipeGrid');
    const deck = deckByOverlay.get(overlay);
    if (!grid || !deck) return false;

    const inline = overlay.hasAttribute('data-vhp-inline');
    const prevScrollY = window.scrollY;
    if (!inline) {
      document.body.style.top = `-${prevScrollY}px`;
      document.body.classList.add('vhp-reel-open');
    }

    overlay.hidden = false;
    overlay.classList.add('is-open');

    const entryBtn = root.querySelector('[data-vhp-reel-entry]');
    if (entryBtn) entryBtn.setAttribute('aria-expanded', 'true');

    const session = loadSession();
    const introEl = overlay.querySelector('[data-native-type="intro"]');

    const state = {
      root,
      grid,
      // Card, peek, media and gestures (assets/vhp-swipe-deck.js), one per overlay.
      deck,
      entryBtn,
      sources: collectSources(grid, api, !window.vhpDeckOrder),
      // Ranked order (rankSources); not for an Explore set, which keeps its own order.
      ranked: root.dataset.feedMode !== 'explore-set',
      rank: null,
      rankIds: null,
      rankTried: new Set(),
      rankToken: 0,
      lead: null,
      front: null,
      progressText: null,
      stripOpen: false,
      calcOpen: false,
      inline,
      // Reel layout (docs/FEED_REEL.md): vertical snap scroll, one button, passes instead of skips.
      reel: overlay.hasAttribute('data-vhp-reel'),
      holdFront: false,
      swipeCount: 0,
      // Deck card rules from the VHP Home Feed section settings.
      session,
      minGap: Number(root.dataset.nativeGap) || 0,
      maxPerVisit: root.dataset.nativeMax == null ? 2 : Number(root.dataset.nativeMax) || 0,
      celebrate: root.dataset.nativeCelebrate !== 'false',
      nativeActive: null,
      nativePreview: false,
      introPending:
        inline &&
        Boolean(introEl) &&
        !(introEl.dataset.onceDevice === 'true' ? flag(introKey(introEl)) : session.intro) &&
        heroWanted(introEl, api),
      readyAtStart: api.planReady(),
      current: null,
      pin: null,
      deferId: null,
      seenUndo: null,
      sinceRevisit: 0,
      revisited: new Set(),
      // Liked cards swiped in the rotation since the last skipped one (deckPlan).
      sinceSkipped: 0,
      doneOpen: false,
      prevScrollY,
      gridObserver: null,
      escHandler: null,
      reelOpenTime: Date.now(),
      wasReady: api.planReady(),
      wasVariety: api.likeCount() >= api.LIKE_VARIETY,
    };
    stateByOverlay.set(overlay, state);
    rankSources(state);

    // Back on the feed in the same session (assets/vhp-home-feed.js): same order, same recipe on top.
    const restore = inline ? window.vhpFeedRestore : null;
    if (restore) {
      window.vhpFeedRestore = null;
      const rank = new Map(restore.order.map((id, i) => [id, i]));
      const known = state.sources.filter((card) => rank.has(card.id)).sort((a, b) => rank.get(a.id) - rank.get(b.id));
      state.sources = known.concat(state.sources.filter((card) => !rank.has(card.id)));
      // The card on top when the feed was left (not swiped yet; may be a liked one from the rotation).
      if (restore.current && state.sources.some((card) => card.id === restore.current)) {
        state.pin = restore.current;
      }
      state.introPending = false;
    } else if (inline && root.dataset.entryCard) {
      // Recipe article: its recipe is the first card, liked or swiped before or not. No intro card in front of it.
      state.pin = root.dataset.entryCard;
      state.introPending = false;
    } else if (inline && root.dataset.firstCard) {
      // First visit: the card the server picked (and preloaded the poster of) goes first, unless already swiped.
      const first = root.dataset.firstCard;
      const doc = api.read();
      const swiped = doc.likes.items.some((item) => item.id === first) || doc.skips.items.some((item) => item.id === first);
      const index = state.sources.findIndex((card) => card.id === first);
      if (!swiped && index > 0) state.sources.unshift(state.sources.splice(index, 1)[0]);
      if (!swiped) state.lead = first;
    }
    // Instagram / Facebook in-app browser on the homepage: the newest recipes first (data-newest, the first of "Neue
    // Rezepte" from the last 14 days: likely the post they came from), in front of the server's first card. Not for
    // the plain-shuffle control group (docs/FEED_ORDER.md).
    const order = window.vhpDeckOrder;
    if (inline && !restore && !root.dataset.entryCard && root.dataset.newest && inAppBrowser() && order) {
      const shuffled = order.rng(order.seed(order.browserSeed(), 'deck'))() < order.SHUFFLE_SHARE;
      const doc = api.read();
      const swiped = new Set([...doc.likes.items, ...doc.skips.items].map((item) => item.id));
      const front = root.dataset.newest
        .split(',')
        .filter((id) => id && !swiped.has(id) && state.sources.some((card) => card.id === id));
      if (!shuffled && front.length) {
        state.front = front;
        rankSources(state);
      }
    }
    // Intro test: the recipes-first arm starts on the first recipe (its intro stays unseen, so ending the test shows
    // it to them on their next visit).
    if (state.introPending && introArm(introEl) === 'h_feed') state.introPending = false;

    if (!inline) {
      state.escHandler = (e) => {
        if (e.key === 'Escape') closeOverlay(overlay);
      };
      document.addEventListener('keydown', state.escHandler);
    }

    state.gridObserver = new MutationObserver(() => {
      const { added, currentGone } = ingestNewCards(state, api);
      if (added && !currentGone && keepTop(overlay, state, api)) return;
      if (added || currentGone || state.deck.card.hidden) showDeck(overlay, state, api);
      else maybeLoadMore(overlay);
    });
    state.gridObserver.observe(grid, { childList: true });

    showDeck(overlay, state, api);
    requestRanking(overlay, state, api);

    if (typeof window.vhpTrack === 'function') {
      window.vhpTrack('reel_open', {
        collection: root.dataset.collectionHandle || root.dataset.listingMode || 'unknown',
        layout: state.reel ? 'reel' : 'swipe',
      });
    }

    return true;
  };

  const closeOverlay = (overlay) => {
    const state = stateByOverlay.get(overlay);
    if (!state) return;

    if (typeof window.vhpTrack === 'function') {
      window.vhpTrack('reel_close', {
        duration_seconds: Math.round((Date.now() - state.reelOpenTime) / 1000),
      });
    }

    pauseVideos(overlay);
    if (state.gridObserver) state.gridObserver.disconnect();
    if (state.escHandler) document.removeEventListener('keydown', state.escHandler);

    overlay.classList.remove('is-open');
    overlay.removeAttribute('data-has-video');
    overlay.removeAttribute('data-dir');
    overlay.hidden = true;

    if (state.entryBtn) state.entryBtn.setAttribute('aria-expanded', 'false');

    document.body.classList.remove('vhp-reel-open');
    document.body.style.top = '';
    window.scrollTo(0, state.prevScrollY);

    if (state.entryBtn) {
      try {
        state.entryBtn.focus({ preventScroll: true });
      } catch (_) {}
    }

    stateByOverlay.delete(overlay);
    stripReelModeParam();
  };

  const tryAutoOpenReel = (root) => {
    if (!isReelModeParam()) return;

    const overlay = root.querySelector('[data-vhp-reel-overlay]');
    if (!overlay) {
      endReelBoot();
      stripReelModeParam();
      return;
    }

    const run = () => {
      try {
        openOverlay(root, overlay);
        stripReelModeParam();
      } finally {
        endReelBoot();
      }
    };

    requestAnimationFrame(() => {
      requestAnimationFrame(run);
    });
  };

  const bindOverlayChrome = (overlay) => {
    if (overlay.dataset.vhpReelChromeBound === '1') return;
    overlay.dataset.vhpReelChromeBound = '1';

    const closeBtn = overlay.querySelector('[data-vhp-reel-close]');
    if (closeBtn) closeBtn.addEventListener('click', () => closeOverlay(overlay));

    overlay.addEventListener('click', (e) => {
      const target = e.target;
      if (!(target instanceof Element)) return;
      // The front card's info and "Rezept" taps open the sheet in assets/vhp-recipe-sheet.js (same selector); here
      // only the reel signal. History cards stop the click in the deck and go through openDetails.
      if (target.closest('[data-vhp-swipe-card] :is(.vhp-swipe-card__badge, .vhp-swipe-card__title, .vhp-swipe-card__macros, .vhp-swipe-card__more, .vhp-swipe-card__info, [data-vhp-swipe-recipe])')) {
        const rState = stateByOverlay.get(overlay);
        if (rState) reelSignal(rState, rState.current, 'recipe_opened', true);
      }
      const share = target.closest('[data-vhp-reel-share]');
      if (share) {
        e.preventDefault();
        e.stopPropagation();
        const state = stateByOverlay.get(overlay);
        if (state) shareCurrent(overlay, state);
        return;
      }
      // Collage intro (docs/HOME_INTRO.md): the planner link remembers its entry (hero) and marks the intro as done.
      const heroGo = target.closest('[data-vhp-hero-go]');
      if (heroGo) {
        const gState = stateByOverlay.get(overlay);
        const gApi = likesApi();
        window.vhpTrack?.('planner_cta_click', {
          source: 'hero',
          likes: gApi ? gApi.likeCount() : 0,
          ready: gApi ? gApi.planReady() : false,
        });
        if (gState && !gState.nativePreview) {
          const hero = heroGo.closest('[data-vhp-native]');
          if (hero?.dataset.onceDevice === 'true') setFlag(introKey(hero));
          gState.session.intro = true;
          saveSession(gState.session);
          plannerEvents('step', 'intro_card', 'done');
        }
        return;
      }
      // "Deine Portion" slide: a goal row commits the target; Anpassen opens the card calculator on the weight step.
      const portionGoal = target.closest('[data-vhp-portion-goal]');
      if (portionGoal) {
        e.preventDefault();
        const pState = stateByOverlay.get(overlay);
        if (pState) portionChosen(overlay, pState, portionGoal.dataset.vhpPortionGoal);
        return;
      }
      if (target.closest('[data-vhp-portion-go]')) {
        // "Für mich berechnen": the card calculator's question flow for the slide's dish; the slide flips to done on
        // vhp:portion-target.
        e.preventDefault();
        const pState = stateByOverlay.get(overlay);
        if (pState?.portionDish) {
          plannerEvents('step', 'calc_use', 'goal_deck');
          openCardCalc(overlay, pState, pState.portionDish);
        }
        return;
      }
      if (target.closest('[data-vhp-portion-adjust]')) {
        e.preventDefault();
        const pState = stateByOverlay.get(overlay);
        if (pState?.portionDish) {
          plannerEvents('step', 'calc_use', 'adjust_deck');
          openCardCalc(overlay, pState, pState.portionDish);
          const sheet = calcSheet(overlay);
          window.vhpPortionCalc?.adjust?.(sheet && $(sheet, '[data-vhp-calc]'));
        }
        return;
      }
      const nativeDismiss = target.closest('[data-vhp-native-dismiss]');
      if (nativeDismiss) {
        e.preventDefault();
        const nState = stateByOverlay.get(overlay);
        const nApi = likesApi();
        // Sören's intro and the collage hero: the button is a yes, so the card leaves like a like (to the right),
        // with a tick on phones.
        const talkEl = nativeDismiss.closest('.vhp-native--talk, .vhp-native--hero');
        if (talkEl) {
          talkEl.dataset.how = 'button';
          navigator.vibrate?.(12);
        }
        if (nState && nApi) nState.deck.flyOut(talkEl ? 'take' : 'skip');
        return;
      }
      const nativeLink = target.closest('[data-vhp-native-link]');
      if (nativeLink) {
        if (typeof window.vhpTrack === 'function') {
          window.vhpTrack('feed_native_click', { card: nativeLink.getAttribute('data-vhp-native-link') });
          if (nativeLink.getAttribute('data-vhp-native-link') === 'planner') {
            const lApi = likesApi();
            window.vhpTrack('planner_cta_click', {
              // The same card in a collection's deck counts apart (vhp-planner docs/entry.md).
              source: window.vhpTrack.pageType?.() === 'collection' ? 'deck_card' : 'feed_card',
              likes: lApi ? lApi.likeCount() : 0,
              ready: lApi ? lApi.planReady() : false,
            });
          }
        }
        return;
      }
      if (target.closest('[data-vhp-done-plan]')) {
        const pApi = likesApi();
        window.vhpTrack?.('planner_cta_click', {
          source: 'feed_done',
          likes: pApi ? pApi.likeCount() : 0,
          ready: pApi ? pApi.planReady() : false,
        });
        return;
      }
      const doneBtn = target.closest('[data-vhp-done-go], [data-vhp-done-alt]');
      if (doneBtn) {
        const dState = stateByOverlay.get(overlay);
        if (dState) closeDone(overlay, dState);
        const alt = doneBtn.dataset.vhpDoneAlt;
        window.vhpTrack?.('feed_all_seen_click', { action: alt || 'more' });
        if (alt === 'likes') window.location.href = '/pages/wunschliste';
        else if (alt === 'filters') document.getElementById('app-filters')?.showPopover?.();
        else if (alt === 'all') window.vhpFeed?.setMode?.('alle-rezepte');
        return;
      }
      if (target.closest('[data-vhp-swipe-foryou]')) {
        e.preventDefault();
        const cState = stateByOverlay.get(overlay);
        if (cState) openCardCalc(overlay, cState);
        return;
      }
      if (target.closest('[data-vhp-card-calc-close]')) {
        e.preventDefault();
        const cState = stateByOverlay.get(overlay);
        if (cState) closeCardCalc(overlay, cState);
        return;
      }
      if (target.closest('[data-vhp-feed-progress]')) {
        const pState = stateByOverlay.get(overlay);
        const pApi = likesApi();
        if (pApi && pApi.planReady()) {
          // "Woche planen": straight into the planner, counted as the progress line's way in (entry feed_strip).
          window.vhpTrack?.('planner_cta_click', { source: 'feed_strip', likes: pApi.likeCount(), ready: true, from: 'pill' });
          window.location.href = overlay.dataset.vhpPlannerUrl || '/pages/meal-planner';
          return;
        }
        if (pState && pApi) openStrip(overlay, pState, pApi);
        return;
      }
      if (target.closest('[data-vhp-feed-strip-close]')) {
        e.preventDefault();
        const sState = stateByOverlay.get(overlay);
        if (sState) closeStrip(overlay, sState);
        return;
      }
      if (target.closest('[data-vhp-feed-strip-go]')) {
        // The link goes to the planner; this decides its planner_entry (assets/vhp-track.js remembers the source).
        const gApi = likesApi();
        window.vhpTrack?.('planner_cta_click', {
          source: 'feed_strip',
          likes: gApi ? gApi.likeCount() : 0,
          ready: gApi ? gApi.planReady() : false,
        });
        return;
      }
      const act = target.closest('[data-vhp-swipe]');
      if (!act) return;
      const state = stateByOverlay.get(overlay);
      const api = likesApi();
      if (!state || !api) return;
      const kind = act.getAttribute('data-vhp-swipe');
      if (kind === 'plan') {
        if (state.current && !state.current.native) {
          overlay.dispatchEvent(new CustomEvent('vhp:card-plan', { bubbles: true, detail: { card: state.current } }));
        }
      } else if (kind === 'undo') undoSwipe(overlay, state, api);
      else if (kind === 'take' || kind === 'skip') {
        // Reel layout: the one button likes (or unlikes) the card on screen; on a native card it moves on.
        if (state.reel) {
          const card = onScreen(state);
          if (!card || card.native) state.deck.flyOut(kind);
          else toggleLike(overlay, state, api, card);
        } else state.deck.flyOut(kind);
      }
    });

    const cta = overlay.querySelector('[data-vhp-reel-plan]');
    if (cta) {
      cta.addEventListener('click', (e) => {
        if (cta.getAttribute('aria-disabled') === 'true') {
          e.preventDefault();
          return;
        }
        if (typeof window.vhpTrack === 'function') {
          window.vhpTrack('reel_plan_cta', {
            paid: overlay.dataset.vhpPlannerPaid === 'true',
          });
        }
      });
    }

    const stateOf = () => stateByOverlay.get(overlay);
    // Reel layout (snippets/vhp-reel-overlay.liquid reel: true) needs its deck script; without it the swipe deck runs.
    const reel = overlay.hasAttribute('data-vhp-reel') && Boolean(window.vhpReelDeck);
    if (!reel) overlay.removeAttribute('data-vhp-reel');
    const deckOpts = {
      canDrag: () => Boolean(stateOf()),
      canSwipe: () => Boolean(stateOf()?.current && likesApi()),
      canTap: () => Boolean(stateOf()?.current && !stateOf().current.native),
      onSwipe: (kind) => {
        const state = stateOf();
        const api = likesApi();
        if (!state || !api) return;
        if (kind === 'take') take(overlay, state, api);
        else skip(overlay, state, api);
      },
      // Inline feed: swipe up opens the recipe (Tinder's "profile"). Not in the reel: a swipe up is the scroll.
      lift:
        overlay.hasAttribute('data-vhp-inline') && !reel
          ? {
              canLift: () => Boolean(stateOf()?.current && !stateOf().current.native),
              onCommit: () => {
                const state = stateOf();
                if (state) openDetails(overlay, state, 'swipe_up');
              },
            }
          : null,
      ignore: '[data-vhp-native] :is(a, button, input, select, textarea, iframe, form)',
      badge: (el, card) => {
        el.textContent = likesApi()?.SLOT_LABEL[card.slot] || '';
      },
      face: (ns, card) => {
        paintForYou(overlay, ns, card);
        if (ns !== 'swipe-under') return;
        const tag = $(overlay, '[data-vhp-swipe-under-liked]');
        if (tag) tag.hidden = !likesApi()?.read().likes.items.some((item) => item.id === card.id);
      },
    };
    const deckCtl = reel
      ? window.vhpReelDeck.create(overlay, {
          ...deckOpts,
          onPass: (card, dwell) => {
            const state = stateOf();
            const api = likesApi();
            if (state && api) pass(overlay, state, api, card, dwell);
          },
          // A history card on screen (null: the front card again): the progress line follows it; each card has its
          // own buttons.
          onActive: (card) => {
            const state = stateOf();
            const api = likesApi();
            if (!state || !api) return;
            paintProgress(overlay, state, api);
            if (card) window.vhpTrack?.('feed_history', { slot: card.slot });
          },
          onLike: (card, slide) => {
            const state = stateOf();
            const api = likesApi();
            if (state && api) toggleLike(overlay, state, api, card);
          },
          onShare: () => {
            const state = stateOf();
            if (state) shareCurrent(overlay, state);
          },
          aheadFace: (el, card) => paintAheadFace(overlay, el, card),
          onRecipe: (card) => {
            const state = stateOf();
            if (state) openDetails(overlay, state, 'history', card);
          },
          onCalc: (card) => {
            const state = stateOf();
            if (state) openCardCalc(overlay, state, card);
          },
          onKeyLike: () => {
            const state = stateOf();
            const api = likesApi();
            if (state && api) toggleLike(overlay, state, api, onScreen(state));
          },
          nudge: () => Boolean(stateOf() && !stateOf().nativeActive),
        })
      : window.vhpSwipeDeck?.create(overlay, deckOpts);
    if (!deckCtl) return;
    deckByOverlay.set(overlay, deckCtl);
    const deck = deckCtl.deckEl;

    if (overlay.hasAttribute('data-vhp-inline') && !reel) {
      // Desktop: scrolling down over the card (wheel / trackpad) opens the recipe, like swiping up.
      let wheelSum = 0;
      let wheelReset = 0;
      let wheelLock = 0;
      deck.addEventListener(
        'wheel',
        (event) => {
          const state = stateByOverlay.get(overlay);
          if (!state || state.deck.card.hidden || Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
          event.preventDefault();
          if (event.deltaY < 0 || Date.now() < wheelLock) return;
          wheelSum += event.deltaY;
          window.clearTimeout(wheelReset);
          wheelReset = window.setTimeout(() => (wheelSum = 0), 250);
          if (wheelSum < 60) return;
          wheelSum = 0;
          wheelLock = Date.now() + 900;
          openDetails(overlay, state, 'wheel');
        },
        { passive: false }
      );

      // Arrow up opens the recipe (left/right stay with the buttons).
      document.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowUp' || event.defaultPrevented || event.altKey || event.ctrlKey || event.metaKey) return;
        if (event.target instanceof Element && event.target.closest('input, textarea, select, [contenteditable], dialog[open], [popover]:popover-open')) return;
        if (document.documentElement.classList.contains('rs-open') || document.querySelector('dialog[open]')) return;
        const state = stateByOverlay.get(overlay);
        if (!state || state.deck.card.hidden || state.calcOpen || state.stripOpen || !overlay.getClientRects().length) return;
        event.preventDefault();
        openDetails(overlay, state, 'key');
      });
    }
  };

  const init = (root) => {
    if (!root) return;
    const overlay = root.querySelector('[data-vhp-reel-overlay]');
    if (!overlay) return;

    bindOverlayChrome(overlay);

    const entry = root.querySelector('[data-vhp-reel-entry]');
    if (entry && entry.dataset.vhpReelEntryBound !== '1') {
      entry.dataset.vhpReelEntryBound = '1';
      entry.addEventListener('click', () => openOverlay(root, overlay));
      if (!isReelModeParam()) playEntryShimmer(entry);
    }

    // Inline feed: open right away, so the first card's poster and video start loading while the rest of the
    // page (third-party scripts) is still busy; waiting for a frame cost ~0.5 s before the first paint.
    if (overlay.hasAttribute('data-vhp-inline')) {
      openOverlay(root, overlay);
      return;
    }

    tryAutoOpenReel(root);
  };

  window.initVhpCollectionReels = init;

  // Used by the homepage feed controller (assets/vhp-home-feed.js).
  const overlayState = (root) => {
    const overlay = root?.querySelector('[data-vhp-reel-overlay]');
    const state = overlay ? stateByOverlay.get(overlay) : null;
    return overlay && state ? { overlay, state } : null;
  };
  window.vhpReels = {
    // Deck order and current recipe, for the feed memory in assets/vhp-home-feed.js.
    snapshot(root) {
      const ctx = overlayState(root);
      if (!ctx) return null;
      const { state } = ctx;
      const current = state.current && !state.current.native ? state.current.id : null;
      return { order: state.sources.map((card) => card.id), current };
    },
    // Filters changed: re-evaluate the deck with the same sources.
    refresh(root) {
      const api = likesApi();
      const ctx = overlayState(root);
      if (!api || !ctx || ctx.state.nativeActive) return;
      ctx.state.pin = null;
      ctx.state.deferId = null;
      ctx.state.seenUndo = null;
      showDeck(ctx.overlay, ctx.state, api);
    },
    // The grid was replaced (feed mode switch): rebuild sources and start over.
    // options.keepOrder: use the grid order (Explore set) instead of ranking.
    // options.pinHandle: show this recipe first. Returns whether it is in the deck.
    reload(root, options) {
      const api = likesApi();
      const ctx = overlayState(root);
      if (!api || !ctx) return false;
      const { overlay, state } = ctx;
      state.sources = collectSources(state.grid, api, !options?.keepOrder && !window.vhpDeckOrder);
      state.ranked = !options?.keepOrder;
      state.rank = null;
      state.rankIds = null;
      state.rankTried = new Set();
      state.lead = null;
      state.front = null;
      rankSources(state);
      state.pin = null;
      if (options?.pinHandle) {
        const hit = state.sources.find((card) => card.handle === options.pinHandle);
        state.pin = hit ? hit.id : null;
      }
      state.deferId = null;
      state.seenUndo = null;
      state.current = null;
      closeDone(overlay, state);
      if (state.nativeActive) dismissNative(overlay, state);
      state.deck.clear?.();
      showDeck(overlay, state, api);
      requestRanking(overlay, state, api);
      return Boolean(options?.pinHandle ? state.pin : true);
    },
  };

  const autoInit = () => {
    document.querySelectorAll('.vhp-collection-section').forEach(init);
  };

  // A portion target was just worked out (the calculator on a card, sheet or recipe page): "Für dich" on the cards.
  document.addEventListener('vhp:portion-target', () => {
    document.querySelectorAll('[data-vhp-reel-overlay]').forEach((overlay) => {
      const state = stateByOverlay.get(overlay);
      if (!state) return;
      repaintForYou(overlay);
      repaintPortion(overlay, state);
    });
  });

  // A like from elsewhere (recipe sheet, "In Woche einplanen") moves the like count on the deck too.
  window.addEventListener('vhp:likes-changed', () => {
    const api = likesApi();
    if (!api) return;
    document.querySelectorAll('[data-vhp-reel-overlay]').forEach((overlay) => {
      const state = stateByOverlay.get(overlay);
      if (state) paintProgress(overlay, state, api);
    });
  });

  // Theme editor: selecting a deck card block shows it right away (without counting it for the visit),
  // deselecting goes back to the recipes. Setting changes re-render the section, so start it again.
  if (window.Shopify?.designMode) {
    const blockCtx = (event) => {
      const el = event.target;
      if (!el?.matches?.('[data-vhp-native]')) return null;
      const overlay = el.closest('[data-vhp-reel-overlay]');
      const state = overlay ? stateByOverlay.get(overlay) : null;
      const api = likesApi();
      return state && api ? { el, overlay, state, api } : null;
    };
    document.addEventListener('shopify:block:select', (event) => {
      const ctx = blockCtx(event);
      if (!ctx) return;
      ctx.state.nativePreview = true;
      if (ctx.state.nativeActive) dismissNative(ctx.overlay, ctx.state);
      showNative(ctx.overlay, ctx.state, ctx.api, ctx.el.dataset.vhpNative, remainingCards(ctx.state, ctx.api));
    });
    document.addEventListener('shopify:block:deselect', (event) => {
      const ctx = blockCtx(event);
      if (!ctx) return;
      if (ctx.state.nativeActive === ctx.el.dataset.vhpNative) dismissNative(ctx.overlay, ctx.state);
      ctx.state.nativePreview = false;
      showDeck(ctx.overlay, ctx.state, ctx.api);
    });
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll?.('.vhp-collection-section').forEach(init);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoInit, { once: true });
  } else {
    autoInit();
  }
})();
